// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { dateRangeFromJson, dateRangeToJson, fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson as vendastatypesPagedRequestOptionsFromJson, pagedRequestOptionsToJson as vendastatypesPagedRequestOptionsToJson, pagedResponseMetadataFromJson as vendastatypesPagedResponseMetadataFromJson, pagedResponseMetadataToJson as vendastatypesPagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function recordToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.subdomain !== undefined)
        o['subdomain'] = m.subdomain;
    if (m.value !== undefined)
        o['value'] = m.value;
    if (m.currentValue !== undefined)
        o['currentValue'] = m.currentValue;
    if (m.verified !== undefined)
        o['verified'] = m.verified;
    return o;
}
export function recordFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : '',
        subdomain: (_b = o['subdomain']) !== null && _b !== void 0 ? _b : '',
        value: (_c = o['value']) !== null && _c !== void 0 ? _c : '',
        currentValue: (_d = o['currentValue']) !== null && _d !== void 0 ? _d : '',
        verified: (_e = o['verified']) !== null && _e !== void 0 ? _e : false,
    };
}
export function emailDomainToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.mail !== undefined)
        o['mail'] = recordToJson(m.mail);
    if (m.dkim1 !== undefined)
        o['dkim1'] = recordToJson(m.dkim1);
    if (m.dkim2 !== undefined)
        o['dkim2'] = recordToJson(m.dkim2);
    if (m.apiKey !== undefined)
        o['apiKey'] = m.apiKey;
    if (m.subUserId !== undefined)
        o['subUserId'] = m.subUserId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.domainId !== undefined)
        o['domainId'] = m.domainId;
    if (m.sendAsEmail !== undefined)
        o['sendAsEmail'] = m.sendAsEmail;
    if (m.sendAsName !== undefined)
        o['sendAsName'] = m.sendAsName;
    if (m.dmarc !== undefined)
        o['dmarc'] = recordToJson(m.dmarc);
    if (m.replyToEmail !== undefined)
        o['replyToEmail'] = m.replyToEmail;
    return o;
}
export function emailDomainFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        businessId: (_b = o['businessId']) !== null && _b !== void 0 ? _b : '',
        domain: (_c = o['domain']) !== null && _c !== void 0 ? _c : '',
        mail: o['mail'] ? recordFromJson(o['mail']) : undefined,
        dkim1: o['dkim1'] ? recordFromJson(o['dkim1']) : undefined,
        dkim2: o['dkim2'] ? recordFromJson(o['dkim2']) : undefined,
        apiKey: (_d = o['apiKey']) !== null && _d !== void 0 ? _d : '',
        subUserId: (_e = o['subUserId']) !== null && _e !== void 0 ? _e : '',
        applicationId: (_f = o['applicationId']) !== null && _f !== void 0 ? _f : '',
        domainId: (_g = o['domainId']) !== null && _g !== void 0 ? _g : '',
        sendAsEmail: (_h = o['sendAsEmail']) !== null && _h !== void 0 ? _h : '',
        sendAsName: (_j = o['sendAsName']) !== null && _j !== void 0 ? _j : '',
        dmarc: o['dmarc'] ? recordFromJson(o['dmarc']) : undefined,
        replyToEmail: (_k = o['replyToEmail']) !== null && _k !== void 0 ? _k : '',
    };
}
export function emailEventToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.eventType !== undefined)
        o['eventType'] = m.eventType;
    if (m.eventTime !== undefined)
        o['eventTime'] = m.eventTime.toISOString();
    if (m.ipAddress !== undefined)
        o['ipAddress'] = m.ipAddress;
    if (m.userAgent !== undefined)
        o['userAgent'] = m.userAgent;
    if (m.urlClicked !== undefined)
        o['urlClicked'] = m.urlClicked;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.urlClickedNormalized !== undefined)
        o['urlClickedNormalized'] = m.urlClickedNormalized;
    if (m.emailAddress !== undefined)
        o['emailAddress'] = m.emailAddress;
    return o;
}
export function emailEventFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
        eventType: (_c = o['eventType']) !== null && _c !== void 0 ? _c : 'EMPTY',
        eventTime: o['eventTime'] ? new Date(o['eventTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        ipAddress: (_d = o['ipAddress']) !== null && _d !== void 0 ? _d : '',
        userAgent: (_e = o['userAgent']) !== null && _e !== void 0 ? _e : '',
        urlClicked: (_f = o['urlClicked']) !== null && _f !== void 0 ? _f : '',
        reason: (_g = o['reason']) !== null && _g !== void 0 ? _g : '',
        urlClickedNormalized: (_h = o['urlClickedNormalized']) !== null && _h !== void 0 ? _h : '',
        emailAddress: (_j = o['emailAddress']) !== null && _j !== void 0 ? _j : '',
    };
}
export function userParticipantToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function userParticipantFromJson(o) {
    var _a;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function contactParticipantToJson(m) {
    const o = {};
    if (m.contactId !== undefined)
        o['contactId'] = m.contactId;
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.parentNamespace !== undefined)
        o['parentNamespace'] = m.parentNamespace;
    return o;
}
export function contactParticipantFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        contactId: (_a = o['contactId']) !== null && _a !== void 0 ? _a : '',
        namespace: (_b = o['namespace']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        email: (_d = o['email']) !== null && _d !== void 0 ? _d : '',
        parentNamespace: (_e = o['parentNamespace']) !== null && _e !== void 0 ? _e : '',
    };
}
export function emailParticipantToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.displayName !== undefined)
        o['displayName'] = m.displayName;
    return o;
}
export function emailParticipantFromJson(o) {
    var _a;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
        displayName: o['displayName'],
    };
}
export function emailRecipientToJson(m) {
    const o = {};
    if (m.participant !== undefined) {
        if (m.participant.type === 'userParticipant') {
            o['userParticipant'] = userParticipantToJson(m.participant.userParticipant);
        }
        if (m.participant.type === 'contactParticipant') {
            o['contactParticipant'] = contactParticipantToJson(m.participant.contactParticipant);
        }
        if (m.participant.type === 'emailParticipant') {
            o['emailParticipant'] = emailParticipantToJson(m.participant.emailParticipant);
        }
    }
    else {
        if (m.userParticipant !== undefined)
            o['userParticipant'] = userParticipantToJson(m.userParticipant);
        if (m.contactParticipant !== undefined)
            o['contactParticipant'] = contactParticipantToJson(m.contactParticipant);
        if (m.emailParticipant !== undefined)
            o['emailParticipant'] = emailParticipantToJson(m.emailParticipant);
    }
    return o;
}
export function emailRecipientFromJson(o) {
    return {
        participant: (() => {
            if (o['userParticipant'] !== undefined)
                return { type: 'userParticipant', userParticipant: o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined };
            if (o['contactParticipant'] !== undefined)
                return { type: 'contactParticipant', contactParticipant: o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined };
            if (o['emailParticipant'] !== undefined)
                return { type: 'emailParticipant', emailParticipant: o['emailParticipant'] ? emailParticipantFromJson(o['emailParticipant']) : undefined };
            return undefined;
        })(),
        userParticipant: o['userParticipant'] !== undefined ? o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined : undefined,
        contactParticipant: o['contactParticipant'] !== undefined ? o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined : undefined,
        emailParticipant: o['emailParticipant'] !== undefined ? o['emailParticipant'] ? emailParticipantFromJson(o['emailParticipant']) : undefined : undefined,
    };
}
export function participantToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.emailAddress !== undefined)
        o['emailAddress'] = m.emailAddress;
    return o;
}
export function participantFromJson(o) {
    var _a, _b;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        emailAddress: (_b = o['emailAddress']) !== null && _b !== void 0 ? _b : '',
    };
}
export function attributeToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function attributeFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function headerToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function headerFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function bucketToJson(m) {
    const o = {};
    if (m.bucketName !== undefined)
        o['bucketName'] = m.bucketName;
    if (m.groupBy !== undefined) {
        if (m.groupBy.type === 'attribute') {
            o['attribute'] = attributeToJson(m.groupBy.attribute);
        }
    }
    else {
        if (m.attribute !== undefined)
            o['attribute'] = attributeToJson(m.attribute);
    }
    return o;
}
export function bucketFromJson(o) {
    var _a;
    return {
        bucketName: (_a = o['bucketName']) !== null && _a !== void 0 ? _a : '',
        groupBy: (() => {
            if (o['attribute'] !== undefined)
                return { type: 'attribute', attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined };
            return undefined;
        })(),
        attribute: o['attribute'] !== undefined ? o['attribute'] ? attributeFromJson(o['attribute']) : undefined : undefined,
    };
}
export function gCSAttachmentToJson(m) {
    const o = {};
    if (m.bucket !== undefined)
        o['bucket'] = m.bucket;
    if (m.filename !== undefined)
        o['filename'] = m.filename;
    if (m.attachedFilename !== undefined)
        o['attachedFilename'] = m.attachedFilename;
    return o;
}
export function gCSAttachmentFromJson(o) {
    var _a, _b, _c;
    return {
        bucket: (_a = o['bucket']) !== null && _a !== void 0 ? _a : '',
        filename: (_b = o['filename']) !== null && _b !== void 0 ? _b : '',
        attachedFilename: (_c = o['attachedFilename']) !== null && _c !== void 0 ? _c : '',
    };
}
export function uRLAttachmentToJson(m) {
    const o = {};
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.attachedFilename !== undefined)
        o['attachedFilename'] = m.attachedFilename;
    return o;
}
export function uRLAttachmentFromJson(o) {
    var _a, _b;
    return {
        fileUrl: (_a = o['fileUrl']) !== null && _a !== void 0 ? _a : '',
        attachedFilename: (_b = o['attachedFilename']) !== null && _b !== void 0 ? _b : '',
    };
}
export function trackedURLAttachmentToJson(m) {
    const o = {};
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.attachedFilename !== undefined)
        o['attachedFilename'] = m.attachedFilename;
    return o;
}
export function trackedURLAttachmentFromJson(o) {
    var _a, _b;
    return {
        fileUrl: (_a = o['fileUrl']) !== null && _a !== void 0 ? _a : '',
        attachedFilename: (_b = o['attachedFilename']) !== null && _b !== void 0 ? _b : '',
    };
}
export function contentToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.value !== undefined)
        o['value'] = m.value;
    if (m.sensitive !== undefined)
        o['sensitive'] = m.sensitive;
    return o;
}
export function contentFromJson(o) {
    var _a, _b, _c;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'TEXT_PLAIN',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
        sensitive: (_c = o['sensitive']) !== null && _c !== void 0 ? _c : false,
    };
}
export function linksToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.normalizedUrl !== undefined)
        o['normalizedUrl'] = m.normalizedUrl;
    return o;
}
export function linksFromJson(o) {
    var _a, _b;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        normalizedUrl: (_b = o['normalizedUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function emailMessageToJson(m) {
    const o = {};
    if (m.to !== undefined) {
        o['to'] = m.to.map(e => participantToJson(e));
    }
    if (m.cc !== undefined) {
        o['cc'] = m.cc.map(e => participantToJson(e));
    }
    if (m.bcc !== undefined) {
        o['bcc'] = m.bcc.map(e => participantToJson(e));
    }
    if (m.from !== undefined)
        o['from'] = participantToJson(m.from);
    if (m.replyTo !== undefined)
        o['replyTo'] = participantToJson(m.replyTo);
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.content !== undefined) {
        o['content'] = m.content.map(e => contentToJson(e));
    }
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp.toISOString();
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => headerToJson(e));
    }
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => gCSAttachmentToJson(e));
    }
    if (m.urlAttachments !== undefined) {
        o['urlAttachments'] = m.urlAttachments.map(e => uRLAttachmentToJson(e));
    }
    if (m.serviceProviderInfo !== undefined)
        o['serviceProviderInfo'] = serviceProviderInfoToJson(m.serviceProviderInfo);
    if (m.links !== undefined) {
        o['links'] = m.links.map(e => linksToJson(e));
    }
    if (m.originUserId !== undefined)
        o['originUserId'] = m.originUserId;
    return o;
}
export function emailMessageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        to: ((_a = o['to']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        cc: ((_b = o['cc']) !== null && _b !== void 0 ? _b : []).map(e => participantFromJson(e)),
        bcc: ((_c = o['bcc']) !== null && _c !== void 0 ? _c : []).map(e => participantFromJson(e)),
        from: o['from'] ? participantFromJson(o['from']) : undefined,
        replyTo: o['replyTo'] ? participantFromJson(o['replyTo']) : undefined,
        subject: (_d = o['subject']) !== null && _d !== void 0 ? _d : '',
        content: ((_e = o['content']) !== null && _e !== void 0 ? _e : []).map(e => contentFromJson(e)),
        attributes: ((_f = o['attributes']) !== null && _f !== void 0 ? _f : []).map(e => attributeFromJson(e)),
        emailId: (_g = o['emailId']) !== null && _g !== void 0 ? _g : '',
        timestamp: o['timestamp'] ? new Date(o['timestamp']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        headers: ((_h = o['headers']) !== null && _h !== void 0 ? _h : []).map(e => headerFromJson(e)),
        attachments: ((_j = o['attachments']) !== null && _j !== void 0 ? _j : []).map(e => gCSAttachmentFromJson(e)),
        urlAttachments: ((_k = o['urlAttachments']) !== null && _k !== void 0 ? _k : []).map(e => uRLAttachmentFromJson(e)),
        serviceProviderInfo: o['serviceProviderInfo'] ? serviceProviderInfoFromJson(o['serviceProviderInfo']) : undefined,
        links: ((_l = o['links']) !== null && _l !== void 0 ? _l : []).map(e => linksFromJson(e)),
        originUserId: (_m = o['originUserId']) !== null && _m !== void 0 ? _m : '',
    };
}
export function emailMessageV2ToJson(m) {
    const o = {};
    if (m.to !== undefined)
        o['to'] = userParticipantToJson(m.to);
    if (m.from !== undefined)
        o['from'] = participantToJson(m.from);
    if (m.replyTo !== undefined)
        o['replyTo'] = participantToJson(m.replyTo);
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.content !== undefined) {
        o['content'] = m.content.map(e => contentToJson(e));
    }
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp.toISOString();
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => headerToJson(e));
    }
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => gCSAttachmentToJson(e));
    }
    if (m.urlAttachments !== undefined) {
        o['urlAttachments'] = m.urlAttachments.map(e => uRLAttachmentToJson(e));
    }
    if (m.serviceProviderInfo !== undefined)
        o['serviceProviderInfo'] = serviceProviderInfoToJson(m.serviceProviderInfo);
    if (m.links !== undefined) {
        o['links'] = m.links.map(e => linksToJson(e));
    }
    return o;
}
export function emailMessageV2FromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        to: o['to'] ? userParticipantFromJson(o['to']) : undefined,
        from: o['from'] ? participantFromJson(o['from']) : undefined,
        replyTo: o['replyTo'] ? participantFromJson(o['replyTo']) : undefined,
        subject: (_a = o['subject']) !== null && _a !== void 0 ? _a : '',
        content: ((_b = o['content']) !== null && _b !== void 0 ? _b : []).map(e => contentFromJson(e)),
        attributes: ((_c = o['attributes']) !== null && _c !== void 0 ? _c : []).map(e => attributeFromJson(e)),
        emailId: (_d = o['emailId']) !== null && _d !== void 0 ? _d : '',
        timestamp: o['timestamp'] ? new Date(o['timestamp']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        headers: ((_e = o['headers']) !== null && _e !== void 0 ? _e : []).map(e => headerFromJson(e)),
        attachments: ((_f = o['attachments']) !== null && _f !== void 0 ? _f : []).map(e => gCSAttachmentFromJson(e)),
        urlAttachments: ((_g = o['urlAttachments']) !== null && _g !== void 0 ? _g : []).map(e => uRLAttachmentFromJson(e)),
        serviceProviderInfo: o['serviceProviderInfo'] ? serviceProviderInfoFromJson(o['serviceProviderInfo']) : undefined,
        links: ((_h = o['links']) !== null && _h !== void 0 ? _h : []).map(e => linksFromJson(e)),
    };
}
export function whiteLabelEmailMessageToJson(m) {
    const o = {};
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.htmlContent !== undefined)
        o['htmlContent'] = m.htmlContent;
    if (m.plainTextContent !== undefined)
        o['plainTextContent'] = m.plainTextContent;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.links !== undefined) {
        o['links'] = m.links.map(e => linksToJson(e));
    }
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => gCSAttachmentToJson(e));
    }
    if (m.urlAttachments !== undefined) {
        o['urlAttachments'] = m.urlAttachments.map(e => uRLAttachmentToJson(e));
    }
    if (m.trackedUrlAttachments !== undefined) {
        o['trackedUrlAttachments'] = m.trackedUrlAttachments.map(e => trackedURLAttachmentToJson(e));
    }
    if (m.trackOpens !== undefined)
        o['trackOpens'] = m.trackOpens;
    if (m.trackClicks !== undefined)
        o['trackClicks'] = m.trackClicks;
    return o;
}
export function whiteLabelEmailMessageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        subject: (_a = o['subject']) !== null && _a !== void 0 ? _a : '',
        htmlContent: (_b = o['htmlContent']) !== null && _b !== void 0 ? _b : '',
        plainTextContent: (_c = o['plainTextContent']) !== null && _c !== void 0 ? _c : '',
        attributes: ((_d = o['attributes']) !== null && _d !== void 0 ? _d : []).map(e => attributeFromJson(e)),
        links: ((_e = o['links']) !== null && _e !== void 0 ? _e : []).map(e => linksFromJson(e)),
        attachments: ((_f = o['attachments']) !== null && _f !== void 0 ? _f : []).map(e => gCSAttachmentFromJson(e)),
        urlAttachments: ((_g = o['urlAttachments']) !== null && _g !== void 0 ? _g : []).map(e => uRLAttachmentFromJson(e)),
        trackedUrlAttachments: ((_h = o['trackedUrlAttachments']) !== null && _h !== void 0 ? _h : []).map(e => trackedURLAttachmentFromJson(e)),
        trackOpens: (_j = o['trackOpens']) !== null && _j !== void 0 ? _j : false,
        trackClicks: (_k = o['trackClicks']) !== null && _k !== void 0 ? _k : false,
    };
}
export function serviceProviderInfoToJson(m) {
    const o = {};
    if (m.subUserId !== undefined)
        o['subUserId'] = m.subUserId;
    return o;
}
export function serviceProviderInfoFromJson(o) {
    var _a;
    return {
        subUserId: (_a = o['subUserId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function emailWithCustomDomainMessageToJson(m) {
    const o = {};
    if (m.to !== undefined) {
        o['to'] = m.to.map(e => participantToJson(e));
    }
    if (m.cc !== undefined) {
        o['cc'] = m.cc.map(e => participantToJson(e));
    }
    if (m.bcc !== undefined) {
        o['bcc'] = m.bcc.map(e => participantToJson(e));
    }
    if (m.replyTo !== undefined)
        o['replyTo'] = participantToJson(m.replyTo);
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.content !== undefined) {
        o['content'] = m.content.map(e => contentToJson(e));
    }
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp.toISOString();
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => headerToJson(e));
    }
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => gCSAttachmentToJson(e));
    }
    if (m.urlAttachments !== undefined) {
        o['urlAttachments'] = m.urlAttachments.map(e => uRLAttachmentToJson(e));
    }
    return o;
}
export function emailWithCustomDomainMessageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        to: ((_a = o['to']) !== null && _a !== void 0 ? _a : []).map(e => participantFromJson(e)),
        cc: ((_b = o['cc']) !== null && _b !== void 0 ? _b : []).map(e => participantFromJson(e)),
        bcc: ((_c = o['bcc']) !== null && _c !== void 0 ? _c : []).map(e => participantFromJson(e)),
        replyTo: o['replyTo'] ? participantFromJson(o['replyTo']) : undefined,
        subject: (_d = o['subject']) !== null && _d !== void 0 ? _d : '',
        content: ((_e = o['content']) !== null && _e !== void 0 ? _e : []).map(e => contentFromJson(e)),
        attributes: ((_f = o['attributes']) !== null && _f !== void 0 ? _f : []).map(e => attributeFromJson(e)),
        emailId: (_g = o['emailId']) !== null && _g !== void 0 ? _g : '',
        timestamp: o['timestamp'] ? new Date(o['timestamp']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        headers: ((_h = o['headers']) !== null && _h !== void 0 ? _h : []).map(e => headerFromJson(e)),
        attachments: ((_j = o['attachments']) !== null && _j !== void 0 ? _j : []).map(e => gCSAttachmentFromJson(e)),
        urlAttachments: ((_k = o['urlAttachments']) !== null && _k !== void 0 ? _k : []).map(e => uRLAttachmentFromJson(e)),
    };
}
export function partnerEmailQuotaToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.dailyQuota !== undefined)
        o['dailyQuota'] = m.dailyQuota;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function partnerEmailQuotaFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        dailyQuota: (_b = o['dailyQuota']) !== null && _b !== void 0 ? _b : 0,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function envelopeToJson(m) {
    const o = {};
    if (m.toField !== undefined) {
        o['toField'] = m.toField.map(e => e);
    }
    if (m.fromField !== undefined)
        o['fromField'] = m.fromField;
    return o;
}
export function envelopeFromJson(o) {
    var _a, _b;
    return {
        toField: ((_a = o['toField']) !== null && _a !== void 0 ? _a : []).map(e => e),
        fromField: (_b = o['fromField']) !== null && _b !== void 0 ? _b : '',
    };
}
export function attachmentInfoToJson(m) {
    const o = {};
    if (m.filename !== undefined)
        o['filename'] = m.filename;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.contentId !== undefined)
        o['contentId'] = m.contentId;
    if (m.charset !== undefined)
        o['charset'] = m.charset;
    if (m.storageObjectName !== undefined)
        o['storageObjectName'] = m.storageObjectName;
    if (m.storageObjectUrl !== undefined)
        o['storageObjectUrl'] = m.storageObjectUrl;
    return o;
}
export function attachmentInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        filename: (_a = o['filename']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        contentType: (_c = o['contentType']) !== null && _c !== void 0 ? _c : '',
        contentId: (_d = o['contentId']) !== null && _d !== void 0 ? _d : '',
        charset: (_e = o['charset']) !== null && _e !== void 0 ? _e : '',
        storageObjectName: (_f = o['storageObjectName']) !== null && _f !== void 0 ? _f : '',
        storageObjectUrl: (_g = o['storageObjectUrl']) !== null && _g !== void 0 ? _g : '',
    };
}
export function inboundMessageToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.headers !== undefined)
        o['headers'] = m.headers;
    if (m.dkim !== undefined)
        o['dkim'] = m.dkim;
    if (m.contentIds !== undefined) {
        o['contentIds'] = m.contentIds.map(e => attributeToJson(e));
    }
    if (m.toField !== undefined) {
        o['toField'] = m.toField.map(e => participantToJson(e));
    }
    if (m.fromField !== undefined)
        o['fromField'] = participantToJson(m.fromField);
    if (m.contentText !== undefined)
        o['contentText'] = m.contentText;
    if (m.contentHtml !== undefined)
        o['contentHtml'] = m.contentHtml;
    if (m.senderIp !== undefined)
        o['senderIp'] = m.senderIp;
    if (m.spamReport !== undefined)
        o['spamReport'] = m.spamReport;
    if (m.envelope !== undefined)
        o['envelope'] = envelopeToJson(m.envelope);
    if (m.attachments !== undefined)
        o['attachments'] = m.attachments;
    if (m.attachmentInfo !== undefined) {
        o['attachmentInfo'] = m.attachmentInfo.map(e => attachmentInfoToJson(e));
    }
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.spamScore !== undefined)
        o['spamScore'] = m.spamScore;
    if (m.charsets !== undefined) {
        o['charsets'] = m.charsets.map(e => attributeToJson(e));
    }
    if (m.spf !== undefined)
        o['spf'] = m.spf;
    if (m.rawMessage !== undefined)
        o['rawMessage'] = m.rawMessage;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function inboundMessageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
        headers: (_b = o['headers']) !== null && _b !== void 0 ? _b : '',
        dkim: (_c = o['dkim']) !== null && _c !== void 0 ? _c : '',
        contentIds: ((_d = o['contentIds']) !== null && _d !== void 0 ? _d : []).map(e => attributeFromJson(e)),
        toField: ((_e = o['toField']) !== null && _e !== void 0 ? _e : []).map(e => participantFromJson(e)),
        fromField: o['fromField'] ? participantFromJson(o['fromField']) : undefined,
        contentText: (_f = o['contentText']) !== null && _f !== void 0 ? _f : '',
        contentHtml: (_g = o['contentHtml']) !== null && _g !== void 0 ? _g : '',
        senderIp: (_h = o['senderIp']) !== null && _h !== void 0 ? _h : '',
        spamReport: (_j = o['spamReport']) !== null && _j !== void 0 ? _j : '',
        envelope: o['envelope'] ? envelopeFromJson(o['envelope']) : undefined,
        attachments: (_k = o['attachments']) !== null && _k !== void 0 ? _k : 0,
        attachmentInfo: ((_l = o['attachmentInfo']) !== null && _l !== void 0 ? _l : []).map(e => attachmentInfoFromJson(e)),
        subject: (_m = o['subject']) !== null && _m !== void 0 ? _m : '',
        spamScore: (_o = o['spamScore']) !== null && _o !== void 0 ? _o : 0,
        charsets: ((_p = o['charsets']) !== null && _p !== void 0 ? _p : []).map(e => attributeFromJson(e)),
        spf: (_q = o['spf']) !== null && _q !== void 0 ? _q : '',
        rawMessage: (_r = o['rawMessage']) !== null && _r !== void 0 ? _r : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function inboundMessageMappingToJson(m) {
    const o = {};
    if (m.mappingId !== undefined)
        o['mappingId'] = m.mappingId;
    if (m.appNamespace !== undefined)
        o['appNamespace'] = m.appNamespace;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function inboundMessageMappingFromJson(o) {
    var _a, _b, _c, _d;
    return {
        mappingId: (_a = o['mappingId']) !== null && _a !== void 0 ? _a : '',
        appNamespace: (_b = o['appNamespace']) !== null && _b !== void 0 ? _b : '',
        idempotencyKey: (_c = o['idempotencyKey']) !== null && _c !== void 0 ? _c : '',
        attributes: ((_d = o['attributes']) !== null && _d !== void 0 ? _d : []).map(e => attributeFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function checkDisposableEmailRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function checkDisposableEmailRequestFromJson(o) {
    var _a;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
    };
}
export function checkDisposableEmailResponseToJson(m) {
    const o = {};
    if (m.isDisposable !== undefined)
        o['isDisposable'] = m.isDisposable;
    return o;
}
export function checkDisposableEmailResponseFromJson(o) {
    var _a;
    return {
        isDisposable: (_a = o['isDisposable']) !== null && _a !== void 0 ? _a : false,
    };
}
export function trackedAttributeToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function trackedAttributeFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function trackedMessageToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.messageId !== undefined)
        o['messageId'] = m.messageId;
    if (m.provider !== undefined)
        o['provider'] = m.provider;
    if (m.content !== undefined)
        o['content'] = trackedMessageContentToJson(m.content);
    if (m.providerMessageId !== undefined)
        o['providerMessageId'] = m.providerMessageId;
    if (m.providerThreadId !== undefined)
        o['providerThreadId'] = m.providerThreadId;
    if (m.providerDraftId !== undefined)
        o['providerDraftId'] = m.providerDraftId;
    if (m.inReplyToMessageId !== undefined)
        o['inReplyToMessageId'] = m.inReplyToMessageId;
    if (m.direction !== undefined)
        o['direction'] = m.direction;
    if (m.connectionId !== undefined)
        o['connectionId'] = m.connectionId;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.messageDate !== undefined)
        o['messageDate'] = m.messageDate.toISOString();
    if (m.participants !== undefined) {
        o['participants'] = m.participants.map(e => trackedMessageParticipantToJson(e));
    }
    if (m.savedToSentItems !== undefined)
        o['savedToSentItems'] = m.savedToSentItems;
    if (m.importance !== undefined)
        o['importance'] = m.importance;
    if (m.source !== undefined)
        o['source'] = m.source;
    if (m.sourceDrillDown1 !== undefined)
        o['sourceDrillDown1'] = m.sourceDrillDown1;
    if (m.sourceDrillDown2 !== undefined)
        o['sourceDrillDown2'] = m.sourceDrillDown2;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => trackedAttributeToJson(e));
    }
    if (m.sendStatus !== undefined)
        o['sendStatus'] = m.sendStatus;
    if (m.sendError !== undefined)
        o['sendError'] = m.sendError;
    if (m.sendRetryCount !== undefined)
        o['sendRetryCount'] = m.sendRetryCount;
    if (m.categoryConfigurationId !== undefined)
        o['categoryConfigurationId'] = m.categoryConfigurationId;
    if (m.categoryConfidence !== undefined)
        o['categoryConfidence'] = m.categoryConfidence;
    if (m.categoryReasoning !== undefined)
        o['categoryReasoning'] = m.categoryReasoning;
    if (m.categoryName !== undefined)
        o['categoryName'] = m.categoryName;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    return o;
}
export function trackedMessageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        messageId: (_b = o['messageId']) !== null && _b !== void 0 ? _b : '',
        provider: (_c = o['provider']) !== null && _c !== void 0 ? _c : 'EMAIL_PROVIDER_INVALID',
        content: o['content'] ? trackedMessageContentFromJson(o['content']) : undefined,
        providerMessageId: (_d = o['providerMessageId']) !== null && _d !== void 0 ? _d : '',
        providerThreadId: (_e = o['providerThreadId']) !== null && _e !== void 0 ? _e : '',
        providerDraftId: (_f = o['providerDraftId']) !== null && _f !== void 0 ? _f : '',
        inReplyToMessageId: (_g = o['inReplyToMessageId']) !== null && _g !== void 0 ? _g : '',
        direction: (_h = o['direction']) !== null && _h !== void 0 ? _h : 'DIRECTION_INVALID',
        connectionId: (_j = o['connectionId']) !== null && _j !== void 0 ? _j : '',
        ownerId: (_k = o['ownerId']) !== null && _k !== void 0 ? _k : '',
        messageDate: o['messageDate'] ? new Date(o['messageDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        participants: ((_l = o['participants']) !== null && _l !== void 0 ? _l : []).map(e => trackedMessageParticipantFromJson(e)),
        savedToSentItems: (_m = o['savedToSentItems']) !== null && _m !== void 0 ? _m : false,
        importance: (_o = o['importance']) !== null && _o !== void 0 ? _o : '',
        source: (_p = o['source']) !== null && _p !== void 0 ? _p : '',
        sourceDrillDown1: (_q = o['sourceDrillDown1']) !== null && _q !== void 0 ? _q : '',
        sourceDrillDown2: (_r = o['sourceDrillDown2']) !== null && _r !== void 0 ? _r : '',
        attributes: ((_s = o['attributes']) !== null && _s !== void 0 ? _s : []).map(e => trackedAttributeFromJson(e)),
        sendStatus: (_t = o['sendStatus']) !== null && _t !== void 0 ? _t : 'SEND_STATUS_INVALID',
        sendError: (_u = o['sendError']) !== null && _u !== void 0 ? _u : '',
        sendRetryCount: (_v = o['sendRetryCount']) !== null && _v !== void 0 ? _v : 0,
        categoryConfigurationId: o['categoryConfigurationId'],
        categoryConfidence: o['categoryConfidence'],
        categoryReasoning: o['categoryReasoning'],
        categoryName: o['categoryName'],
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function trackedMessageContentToJson(m) {
    const o = {};
    if (m.contentId !== undefined)
        o['contentId'] = m.contentId;
    if (m.visibility !== undefined)
        o['visibility'] = m.visibility;
    if (m.subject !== undefined)
        o['subject'] = m.subject;
    if (m.htmlContent !== undefined)
        o['htmlContent'] = m.htmlContent;
    if (m.plainTextContent !== undefined)
        o['plainTextContent'] = m.plainTextContent;
    if (m.redacted !== undefined)
        o['redacted'] = m.redacted.toISOString();
    return o;
}
export function trackedMessageContentFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        contentId: (_a = o['contentId']) !== null && _a !== void 0 ? _a : '',
        visibility: (_b = o['visibility']) !== null && _b !== void 0 ? _b : 'VISIBILITY_INVALID',
        subject: (_c = o['subject']) !== null && _c !== void 0 ? _c : '',
        htmlContent: (_d = o['htmlContent']) !== null && _d !== void 0 ? _d : '',
        plainTextContent: (_e = o['plainTextContent']) !== null && _e !== void 0 ? _e : '',
        redacted: o['redacted'] ? new Date(o['redacted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function trackedMessageParticipantToJson(m) {
    const o = {};
    if (m.participantId !== undefined)
        o['participantId'] = m.participantId;
    if (m.participantType !== undefined)
        o['participantType'] = m.participantType;
    if (m.contactId !== undefined)
        o['contactId'] = m.contactId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.emailAddress !== undefined)
        o['emailAddress'] = m.emailAddress;
    if (m.displayName !== undefined)
        o['displayName'] = m.displayName;
    return o;
}
export function trackedMessageParticipantFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        participantId: (_a = o['participantId']) !== null && _a !== void 0 ? _a : '',
        participantType: (_b = o['participantType']) !== null && _b !== void 0 ? _b : 'PARTICIPANT_TYPE_INVALID',
        contactId: (_c = o['contactId']) !== null && _c !== void 0 ? _c : '',
        userId: (_d = o['userId']) !== null && _d !== void 0 ? _d : '',
        emailAddress: (_e = o['emailAddress']) !== null && _e !== void 0 ? _e : '',
        displayName: (_f = o['displayName']) !== null && _f !== void 0 ? _f : '',
    };
}
export function getMultiTrackedMessageRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.trackedMessageIds !== undefined) {
        o['trackedMessageIds'] = m.trackedMessageIds.map(e => e);
    }
    return o;
}
export function getMultiTrackedMessageRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        trackedMessageIds: ((_b = o['trackedMessageIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiTrackedMessageResponseToJson(m) {
    const o = {};
    if (m.trackedMessages !== undefined) {
        o['trackedMessages'] = m.trackedMessages.map(e => getMultiTrackedMessageResponseTrackedMessageResultToJson(e));
    }
    return o;
}
export function getMultiTrackedMessageResponseFromJson(o) {
    var _a;
    return {
        trackedMessages: ((_a = o['trackedMessages']) !== null && _a !== void 0 ? _a : []).map(e => getMultiTrackedMessageResponseTrackedMessageResultFromJson(e)),
    };
}
export function getMultiTrackedMessageResponseTrackedMessageResultToJson(m) {
    const o = {};
    if (m.trackedMessageId !== undefined)
        o['trackedMessageId'] = m.trackedMessageId;
    if (m.trackedMessage !== undefined)
        o['trackedMessage'] = trackedMessageToJson(m.trackedMessage);
    if (m.statusCode !== undefined)
        o['statusCode'] = m.statusCode;
    return o;
}
export function getMultiTrackedMessageResponseTrackedMessageResultFromJson(o) {
    var _a, _b;
    return {
        trackedMessageId: (_a = o['trackedMessageId']) !== null && _a !== void 0 ? _a : '',
        trackedMessage: o['trackedMessage'] ? trackedMessageFromJson(o['trackedMessage']) : undefined,
        statusCode: (_b = o['statusCode']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function messageCategoryToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.color !== undefined)
        o['color'] = m.color;
    if (m.position !== undefined)
        o['position'] = m.position;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.gmailLabelId !== undefined)
        o['gmailLabelId'] = m.gmailLabelId;
    if (m.outlookCategory !== undefined)
        o['outlookCategory'] = m.outlookCategory;
    return o;
}
export function messageCategoryFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        color: (_b = o['color']) !== null && _b !== void 0 ? _b : '',
        position: (_c = o['position']) !== null && _c !== void 0 ? _c : 0,
        description: (_d = o['description']) !== null && _d !== void 0 ? _d : '',
        gmailLabelId: (_e = o['gmailLabelId']) !== null && _e !== void 0 ? _e : '',
        outlookCategory: (_f = o['outlookCategory']) !== null && _f !== void 0 ? _f : '',
    };
}
export function inboundEmailConfigToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.configurationId !== undefined)
        o['configurationId'] = m.configurationId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => messageCategoryToJson(e));
    }
    if (m.trackingMode !== undefined)
        o['trackingMode'] = m.trackingMode;
    if (m.defaultInboundVisibility !== undefined)
        o['defaultInboundVisibility'] = m.defaultInboundVisibility;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.draftSyncEnabled !== undefined)
        o['draftSyncEnabled'] = m.draftSyncEnabled;
    return o;
}
export function inboundEmailConfigFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        configurationId: (_b = o['configurationId']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        categories: ((_d = o['categories']) !== null && _d !== void 0 ? _d : []).map(e => messageCategoryFromJson(e)),
        trackingMode: (_e = o['trackingMode']) !== null && _e !== void 0 ? _e : 'TRACKING_MODE_INVALID',
        defaultInboundVisibility: (_f = o['defaultInboundVisibility']) !== null && _f !== void 0 ? _f : 'VISIBILITY_INVALID',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        draftSyncEnabled: (_g = o['draftSyncEnabled']) !== null && _g !== void 0 ? _g : false,
    };
}
export function appliedInboundEmailConfigToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.configurationId !== undefined)
        o['configurationId'] = m.configurationId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    return o;
}
export function appliedInboundEmailConfigFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        configurationId: (_c = o['configurationId']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function createInboundEmailConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => messageCategoryToJson(e));
    }
    if (m.trackingMode !== undefined)
        o['trackingMode'] = m.trackingMode;
    if (m.defaultInboundVisibility !== undefined)
        o['defaultInboundVisibility'] = m.defaultInboundVisibility;
    if (m.draftSyncEnabled !== undefined)
        o['draftSyncEnabled'] = m.draftSyncEnabled;
    return o;
}
export function createInboundEmailConfigRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        categories: ((_c = o['categories']) !== null && _c !== void 0 ? _c : []).map(e => messageCategoryFromJson(e)),
        trackingMode: (_d = o['trackingMode']) !== null && _d !== void 0 ? _d : 'TRACKING_MODE_INVALID',
        defaultInboundVisibility: (_e = o['defaultInboundVisibility']) !== null && _e !== void 0 ? _e : 'VISIBILITY_INVALID',
        draftSyncEnabled: (_f = o['draftSyncEnabled']) !== null && _f !== void 0 ? _f : false,
    };
}
export function createInboundEmailConfigResponseToJson(m) {
    const o = {};
    if (m.configurationId !== undefined)
        o['configurationId'] = m.configurationId;
    return o;
}
export function createInboundEmailConfigResponseFromJson(o) {
    var _a;
    return {
        configurationId: (_a = o['configurationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateInboundEmailConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.configuration !== undefined)
        o['configuration'] = inboundEmailConfigToJson(m.configuration);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateInboundEmailConfigRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        configuration: o['configuration'] ? inboundEmailConfigFromJson(o['configuration']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function updateInboundEmailConfigResponseToJson(m) {
    const o = {};
    return o;
}
export function updateInboundEmailConfigResponseFromJson(o) {
    return {};
}
export function getMultiInboundEmailConfigsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.configurationIds !== undefined) {
        o['configurationIds'] = m.configurationIds.map(e => e);
    }
    return o;
}
export function getMultiInboundEmailConfigsRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        configurationIds: ((_b = o['configurationIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiInboundEmailConfigsResponseToJson(m) {
    const o = {};
    if (m.configurations !== undefined) {
        o['configurations'] = m.configurations.map(e => inboundEmailConfigToJson(e));
    }
    return o;
}
export function getMultiInboundEmailConfigsResponseFromJson(o) {
    var _a;
    return {
        configurations: ((_a = o['configurations']) !== null && _a !== void 0 ? _a : []).map(e => inboundEmailConfigFromJson(e)),
    };
}
export function listInboundEmailConfigsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listInboundEmailConfigsRequestFromJson(o) {
    var _a;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listInboundEmailConfigsResponseToJson(m) {
    const o = {};
    if (m.configurations !== undefined) {
        o['configurations'] = m.configurations.map(e => inboundEmailConfigToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listInboundEmailConfigsResponseFromJson(o) {
    var _a;
    return {
        configurations: ((_a = o['configurations']) !== null && _a !== void 0 ? _a : []).map(e => inboundEmailConfigFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function applyInboundEmailConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.configurationId !== undefined)
        o['configurationId'] = m.configurationId;
    return o;
}
export function applyInboundEmailConfigRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        configurationId: (_c = o['configurationId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function applyInboundEmailConfigResponseToJson(m) {
    const o = {};
    if (m.appliedConfiguration !== undefined)
        o['appliedConfiguration'] = appliedInboundEmailConfigToJson(m.appliedConfiguration);
    return o;
}
export function applyInboundEmailConfigResponseFromJson(o) {
    return {
        appliedConfiguration: o['appliedConfiguration'] ? appliedInboundEmailConfigFromJson(o['appliedConfiguration']) : undefined,
    };
}
export function getAppliedInboundEmailConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getAppliedInboundEmailConfigRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getAppliedInboundEmailConfigResponseToJson(m) {
    const o = {};
    if (m.appliedConfiguration !== undefined)
        o['appliedConfiguration'] = appliedInboundEmailConfigToJson(m.appliedConfiguration);
    return o;
}
export function getAppliedInboundEmailConfigResponseFromJson(o) {
    return {
        appliedConfiguration: o['appliedConfiguration'] ? appliedInboundEmailConfigFromJson(o['appliedConfiguration']) : undefined,
    };
}
export function deleteInboundEmailConfigRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.configurationId !== undefined)
        o['configurationId'] = m.configurationId;
    return o;
}
export function deleteInboundEmailConfigRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        configurationId: (_b = o['configurationId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function senderToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.appNamespace !== undefined)
        o['appNamespace'] = m.appNamespace;
    return o;
}
export function senderFromJson(o) {
    var _a, _b, _c;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        appNamespace: (_c = o['appNamespace']) !== null && _c !== void 0 ? _c : '',
    };
}
export function customSenderToJson(m) {
    const o = {};
    if (m.customEmailUsername !== undefined)
        o['customEmailUsername'] = m.customEmailUsername;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.replyTo !== undefined)
        o['replyTo'] = m.replyTo;
    return o;
}
export function customSenderFromJson(o) {
    var _a, _b, _c;
    return {
        customEmailUsername: (_a = o['customEmailUsername']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        replyTo: (_c = o['replyTo']) !== null && _c !== void 0 ? _c : '',
    };
}
export function pagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function pagedResponseMetadataFromJson(o) {
    var _a, _b, _c;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        totalResults: (_c = o['totalResults']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function pagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function listEmailEventsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listEmailEventsRequestListEmailEventsFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listEmailEventsRequestFromJson(o) {
    return {
        filters: o['filters'] ? listEmailEventsRequestListEmailEventsFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listEmailEventsRequestListEmailEventsFiltersToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function listEmailEventsRequestListEmailEventsFiltersFromJson(o) {
    var _a, _b, _c;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listEmailEventsResponseToJson(m) {
    const o = {};
    if (m.events !== undefined) {
        o['events'] = m.events.map(e => emailEventToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    return o;
}
export function listEmailEventsResponseFromJson(o) {
    var _a, _b;
    return {
        events: ((_a = o['events']) !== null && _a !== void 0 ? _a : []).map(e => emailEventFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
    };
}
export function emailEventFilterToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.notificationTypes !== undefined) {
        o['notificationTypes'] = m.notificationTypes.map(e => e);
    }
    if (m.eventTypes !== undefined) {
        o['eventTypes'] = m.eventTypes.map(e => e);
    }
    if (m.dateRange !== undefined)
        o['dateRange'] = dateRangeToJson(m.dateRange);
    return o;
}
export function emailEventFilterFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        notificationTypes: ((_c = o['notificationTypes']) !== null && _c !== void 0 ? _c : []).map(e => e),
        eventTypes: ((_d = o['eventTypes']) !== null && _d !== void 0 ? _d : []).map(e => e),
        dateRange: o['dateRange'] ? dateRangeFromJson(o['dateRange']) : undefined,
    };
}
export function getMultiEmailRollupsRequestToJson(m) {
    const o = {};
    if (m.buckets !== undefined) {
        o['buckets'] = m.buckets.map(e => bucketToJson(e));
    }
    if (m.filter !== undefined)
        o['filter'] = emailEventFilterToJson(m.filter);
    return o;
}
export function getMultiEmailRollupsRequestFromJson(o) {
    var _a;
    return {
        buckets: ((_a = o['buckets']) !== null && _a !== void 0 ? _a : []).map(e => bucketFromJson(e)),
        filter: o['filter'] ? emailEventFilterFromJson(o['filter']) : undefined,
    };
}
export function getMultiEmailRollupsResponseToJson(m) {
    const o = {};
    if (m.emailRollups !== undefined) {
        o['emailRollups'] = m.emailRollups.map(e => emailEventBucketToJson(e));
    }
    return o;
}
export function getMultiEmailRollupsResponseFromJson(o) {
    var _a;
    return {
        emailRollups: ((_a = o['emailRollups']) !== null && _a !== void 0 ? _a : []).map(e => emailEventBucketFromJson(e)),
    };
}
export function emailEventBucketToJson(m) {
    const o = {};
    if (m.bucketName !== undefined)
        o['bucketName'] = m.bucketName;
    if (m.eventRollup !== undefined) {
        o['eventRollup'] = m.eventRollup.map(e => emailEventBucketEventRollupToJson(e));
    }
    return o;
}
export function emailEventBucketFromJson(o) {
    var _a, _b;
    return {
        bucketName: (_a = o['bucketName']) !== null && _a !== void 0 ? _a : '',
        eventRollup: ((_b = o['eventRollup']) !== null && _b !== void 0 ? _b : []).map(e => emailEventBucketEventRollupFromJson(e)),
    };
}
export function emailEventBucketEventRollupToJson(m) {
    const o = {};
    if (m.date !== undefined)
        o['date'] = m.date.toISOString();
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    return o;
}
export function emailEventBucketEventRollupFromJson(o) {
    var _a;
    return {
        date: o['date'] ? new Date(o['date']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        quantity: (_a = o['quantity']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function listEventsForAttributesRequestToJson(m) {
    const o = {};
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.eventTypes !== undefined) {
        o['eventTypes'] = m.eventTypes.map(e => e);
    }
    if (m.excludeProbablyBot !== undefined)
        o['excludeProbablyBot'] = m.excludeProbablyBot;
    if (m.showOnlyLatestEventPerRecipient !== undefined)
        o['showOnlyLatestEventPerRecipient'] = m.showOnlyLatestEventPerRecipient;
    if (m.dateRange !== undefined)
        o['dateRange'] = dateRangeToJson(m.dateRange);
    return o;
}
export function listEventsForAttributesRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        eventTypes: ((_c = o['eventTypes']) !== null && _c !== void 0 ? _c : []).map(e => e),
        excludeProbablyBot: (_d = o['excludeProbablyBot']) !== null && _d !== void 0 ? _d : false,
        showOnlyLatestEventPerRecipient: (_e = o['showOnlyLatestEventPerRecipient']) !== null && _e !== void 0 ? _e : false,
        dateRange: o['dateRange'] ? dateRangeFromJson(o['dateRange']) : undefined,
    };
}
export function listEventsForAttributesResponseToJson(m) {
    const o = {};
    if (m.events !== undefined) {
        o['events'] = m.events.map(e => emailEventToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listEventsForAttributesResponseFromJson(o) {
    var _a, _b, _c;
    return {
        events: ((_a = o['events']) !== null && _a !== void 0 ? _a : []).map(e => emailEventFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getAttributeEventStatsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    return o;
}
export function getAttributeEventStatsRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
    };
}
export function getAttributeEventStatsResponseToJson(m) {
    const o = {};
    if (m.data !== undefined) {
        o['data'] = m.data.map(e => getAttributeEventStatsResponseEventStatsToJson(e));
    }
    if (m.deliveryRate !== undefined)
        o['deliveryRate'] = m.deliveryRate;
    if (m.openRate !== undefined)
        o['openRate'] = m.openRate;
    if (m.clickToOpenRate !== undefined)
        o['clickToOpenRate'] = m.clickToOpenRate;
    return o;
}
export function getAttributeEventStatsResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        data: ((_a = o['data']) !== null && _a !== void 0 ? _a : []).map(e => getAttributeEventStatsResponseEventStatsFromJson(e)),
        deliveryRate: (_b = o['deliveryRate']) !== null && _b !== void 0 ? _b : 0,
        openRate: (_c = o['openRate']) !== null && _c !== void 0 ? _c : 0,
        clickToOpenRate: (_d = o['clickToOpenRate']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function getAttributeEventStatsResponseEventStatsToJson(m) {
    const o = {};
    if (m.eventType !== undefined)
        o['eventType'] = m.eventType;
    if (m.count !== undefined)
        o['count'] = m.count;
    if (m.uniqueCount !== undefined)
        o['uniqueCount'] = m.uniqueCount;
    if (m.uniqueRecipients !== undefined)
        o['uniqueRecipients'] = m.uniqueRecipients;
    return o;
}
export function getAttributeEventStatsResponseEventStatsFromJson(o) {
    var _a, _b, _c, _d;
    return {
        eventType: (_a = o['eventType']) !== null && _a !== void 0 ? _a : 'EMPTY',
        count: (_b = o['count']) !== null && _b !== void 0 ? _b : 0,
        uniqueCount: (_c = o['uniqueCount']) !== null && _c !== void 0 ? _c : 0,
        uniqueRecipients: (_d = o['uniqueRecipients']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function exportAttributeEventClickStatsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.normalizedUrl !== undefined)
        o['normalizedUrl'] = m.normalizedUrl;
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function exportAttributeEventClickStatsRequestFromJson(o) {
    var _a, _b;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        normalizedUrl: (_a = o['normalizedUrl']) !== null && _a !== void 0 ? _a : '',
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getAttributeEventLinkStatsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    return o;
}
export function getAttributeEventLinkStatsRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
    };
}
export function linkStatsToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.totalClicks !== undefined)
        o['totalClicks'] = m.totalClicks;
    if (m.uniqueClicks !== undefined)
        o['uniqueClicks'] = m.uniqueClicks;
    if (m.clickRate !== undefined)
        o['clickRate'] = m.clickRate;
    return o;
}
export function linkStatsFromJson(o) {
    var _a, _b, _c, _d;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        totalClicks: (_b = o['totalClicks']) !== null && _b !== void 0 ? _b : 0,
        uniqueClicks: (_c = o['uniqueClicks']) !== null && _c !== void 0 ? _c : 0,
        clickRate: (_d = o['clickRate']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function getAttributeEventLinkStatsResponseToJson(m) {
    const o = {};
    if (m.data !== undefined) {
        o['data'] = m.data.map(e => linkStatsToJson(e));
    }
    return o;
}
export function getAttributeEventLinkStatsResponseFromJson(o) {
    var _a;
    return {
        data: ((_a = o['data']) !== null && _a !== void 0 ? _a : []).map(e => linkStatsFromJson(e)),
    };
}
export function listLinkClickActivityForAttributeRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.attribute !== undefined)
        o['attribute'] = attributeToJson(m.attribute);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = listLinkClickActivityForAttributeRequestPagedRequestOptionsToJson(m.pagingOptions);
    if (m.normalizedUrl !== undefined)
        o['normalizedUrl'] = m.normalizedUrl;
    return o;
}
export function listLinkClickActivityForAttributeRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        attribute: o['attribute'] ? attributeFromJson(o['attribute']) : undefined,
        pagingOptions: o['pagingOptions'] ? listLinkClickActivityForAttributeRequestPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        normalizedUrl: (_a = o['normalizedUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listLinkClickActivityForAttributeRequestPagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function listLinkClickActivityForAttributeRequestPagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function linkClickStatsToJson(m) {
    const o = {};
    if (m.recipient !== undefined)
        o['recipient'] = linkClickStatsRecipientToJson(m.recipient);
    if (m.recentDate !== undefined)
        o['recentDate'] = m.recentDate.toISOString();
    if (m.count !== undefined)
        o['count'] = m.count;
    return o;
}
export function linkClickStatsFromJson(o) {
    var _a;
    return {
        recipient: o['recipient'] ? linkClickStatsRecipientFromJson(o['recipient']) : undefined,
        recentDate: o['recentDate'] ? new Date(o['recentDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        count: (_a = o['count']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function linkClickStatsRecipientToJson(m) {
    const o = {};
    if (m.emailAddress !== undefined)
        o['emailAddress'] = m.emailAddress;
    return o;
}
export function linkClickStatsRecipientFromJson(o) {
    var _a;
    return {
        emailAddress: (_a = o['emailAddress']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listLinkClickActivityForAttributeResponseToJson(m) {
    const o = {};
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    if (m.data !== undefined) {
        o['data'] = m.data.map(e => linkClickStatsToJson(e));
    }
    return o;
}
export function listLinkClickActivityForAttributeResponseFromJson(o) {
    var _a;
    return {
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
        data: ((_a = o['data']) !== null && _a !== void 0 ? _a : []).map(e => linkClickStatsFromJson(e)),
    };
}
export function inboundMessageMappingOptionsToJson(m) {
    const o = {};
    if (m.appNamespace !== undefined)
        o['appNamespace'] = m.appNamespace;
    if (m.ownerId !== undefined)
        o['ownerId'] = m.ownerId;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    return o;
}
export function inboundMessageMappingOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        appNamespace: (_a = o['appNamespace']) !== null && _a !== void 0 ? _a : '',
        ownerId: (_b = o['ownerId']) !== null && _b !== void 0 ? _b : '',
        attributes: ((_c = o['attributes']) !== null && _c !== void 0 ? _c : []).map(e => attributeFromJson(e)),
    };
}
export function sendRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = emailMessageToJson(m.email);
    if (m.espId !== undefined)
        o['espId'] = m.espId;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function sendRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        email: o['email'] ? emailMessageFromJson(o['email']) : undefined,
        espId: (_a = o['espId']) !== null && _a !== void 0 ? _a : '',
        idempotencyKey: (_b = o['idempotencyKey']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        applicationId: (_d = o['applicationId']) !== null && _d !== void 0 ? _d : '',
        businessId: (_e = o['businessId']) !== null && _e !== void 0 ? _e : '',
    };
}
export function sendResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendV2RequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = emailMessageV2ToJson(m.email);
    if (m.espId !== undefined)
        o['espId'] = m.espId;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function sendV2RequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        email: o['email'] ? emailMessageV2FromJson(o['email']) : undefined,
        espId: (_a = o['espId']) !== null && _a !== void 0 ? _a : '',
        idempotencyKey: (_b = o['idempotencyKey']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        applicationId: (_d = o['applicationId']) !== null && _d !== void 0 ? _d : '',
        businessId: (_e = o['businessId']) !== null && _e !== void 0 ? _e : '',
    };
}
export function sendV2ResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendV2ResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendWithCustomDomainRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = emailWithCustomDomainMessageToJson(m.email);
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.fallbackEmail !== undefined)
        o['fallbackEmail'] = m.fallbackEmail;
    if (m.fallbackName !== undefined)
        o['fallbackName'] = m.fallbackName;
    if (m.fallbackEspId !== undefined)
        o['fallbackEspId'] = m.fallbackEspId;
    return o;
}
export function sendWithCustomDomainRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        email: o['email'] ? emailWithCustomDomainMessageFromJson(o['email']) : undefined,
        idempotencyKey: (_a = o['idempotencyKey']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        applicationId: (_c = o['applicationId']) !== null && _c !== void 0 ? _c : '',
        businessId: (_d = o['businessId']) !== null && _d !== void 0 ? _d : '',
        fallbackEmail: (_e = o['fallbackEmail']) !== null && _e !== void 0 ? _e : '',
        fallbackName: (_f = o['fallbackName']) !== null && _f !== void 0 ? _f : '',
        fallbackEspId: (_g = o['fallbackEspId']) !== null && _g !== void 0 ? _g : '',
    };
}
export function sendWithCustomDomainResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.customDomainUsed !== undefined)
        o['customDomainUsed'] = m.customDomainUsed;
    return o;
}
export function sendWithCustomDomainResponseFromJson(o) {
    var _a, _b;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
        customDomainUsed: (_b = o['customDomainUsed']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listEmailsRequestToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.filters !== undefined)
        o['filters'] = listEmailsRequestListEmailsFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = vendastatypesPagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listEmailsRequestFromJson(o) {
    var _a;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        filters: o['filters'] ? listEmailsRequestListEmailsFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? vendastatypesPagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listEmailsRequestListEmailsFiltersToJson(m) {
    const o = {};
    if (m.to !== undefined)
        o['to'] = m.to;
    if (m.from !== undefined)
        o['from'] = m.from;
    if (m.dateRange !== undefined)
        o['dateRange'] = dateRangeToJson(m.dateRange);
    if (m.espId !== undefined)
        o['espId'] = m.espId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.espIds !== undefined) {
        o['espIds'] = m.espIds.map(e => e);
    }
    if (m.subuserId !== undefined)
        o['subuserId'] = m.subuserId;
    return o;
}
export function listEmailsRequestListEmailsFiltersFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        to: (_a = o['to']) !== null && _a !== void 0 ? _a : '',
        from: (_b = o['from']) !== null && _b !== void 0 ? _b : '',
        dateRange: o['dateRange'] ? dateRangeFromJson(o['dateRange']) : undefined,
        espId: (_c = o['espId']) !== null && _c !== void 0 ? _c : '',
        partnerId: (_d = o['partnerId']) !== null && _d !== void 0 ? _d : '',
        applicationId: (_e = o['applicationId']) !== null && _e !== void 0 ? _e : '',
        businessId: (_f = o['businessId']) !== null && _f !== void 0 ? _f : '',
        espIds: ((_g = o['espIds']) !== null && _g !== void 0 ? _g : []).map(e => e),
        subuserId: (_h = o['subuserId']) !== null && _h !== void 0 ? _h : '',
    };
}
export function listEmailsResponseToJson(m) {
    const o = {};
    if (m.emails !== undefined) {
        o['emails'] = m.emails.map(e => emailMessageToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listEmailsResponseFromJson(o) {
    var _a;
    return {
        emails: ((_a = o['emails']) !== null && _a !== void 0 ? _a : []).map(e => emailMessageFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getEmailQueuesStatusResponseToJson(m) {
    const o = {};
    if (m.running !== undefined)
        o['running'] = m.running;
    return o;
}
export function getEmailQueuesStatusResponseFromJson(o) {
    var _a;
    return {
        running: (_a = o['running']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getEmailQueuesStatusRequestToJson(m) {
    const o = {};
    return o;
}
export function getEmailQueuesStatusRequestFromJson(o) {
    return {};
}
export function setEmailQueuesStatusRequestToJson(m) {
    const o = {};
    if (m.running !== undefined)
        o['running'] = m.running;
    return o;
}
export function setEmailQueuesStatusRequestFromJson(o) {
    var _a;
    return {
        running: (_a = o['running']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getEmailDomainRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function getEmailDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getEmailDomainResponseToJson(m) {
    const o = {};
    if (m.domain !== undefined)
        o['domain'] = emailDomainToJson(m.domain);
    return o;
}
export function getEmailDomainResponseFromJson(o) {
    return {
        domain: o['domain'] ? emailDomainFromJson(o['domain']) : undefined,
    };
}
export function backfillEmailDomainCreatedSubUserToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.subuserId !== undefined)
        o['subuserId'] = m.subuserId;
    return o;
}
export function backfillEmailDomainCreatedSubUserFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
        subuserId: (_d = o['subuserId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function backfillEmailDomainCreatedSubUserRequestToJson(m) {
    const o = {};
    if (m.data !== undefined) {
        o['data'] = m.data.map(e => backfillEmailDomainCreatedSubUserToJson(e));
    }
    return o;
}
export function backfillEmailDomainCreatedSubUserRequestFromJson(o) {
    var _a;
    return {
        data: ((_a = o['data']) !== null && _a !== void 0 ? _a : []).map(e => backfillEmailDomainCreatedSubUserFromJson(e)),
    };
}
export function backfillEmailDomainCreatedSubUserResponseToJson(m) {
    const o = {};
    if (m.data !== undefined) {
        o['data'] = m.data.map(e => backfillEmailDomainCreatedSubUserToJson(e));
    }
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function backfillEmailDomainCreatedSubUserResponseFromJson(o) {
    var _a, _b;
    return {
        data: ((_a = o['data']) !== null && _a !== void 0 ? _a : []).map(e => backfillEmailDomainCreatedSubUserFromJson(e)),
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : '',
    };
}
export function createEmailDomainRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    return o;
}
export function createEmailDomainRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
        userId: (_d = o['userId']) !== null && _d !== void 0 ? _d : '',
        domain: (_e = o['domain']) !== null && _e !== void 0 ? _e : '',
    };
}
export function createEmailDomainWithSendAsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.sendAsEmail !== undefined)
        o['sendAsEmail'] = m.sendAsEmail;
    if (m.sendAsName !== undefined)
        o['sendAsName'] = m.sendAsName;
    return o;
}
export function createEmailDomainWithSendAsRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
        userId: (_d = o['userId']) !== null && _d !== void 0 ? _d : '',
        domain: (_e = o['domain']) !== null && _e !== void 0 ? _e : '',
        sendAsEmail: (_f = o['sendAsEmail']) !== null && _f !== void 0 ? _f : '',
        sendAsName: (_g = o['sendAsName']) !== null && _g !== void 0 ? _g : '',
    };
}
export function verifyEmailDomainRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function verifyEmailDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function verifyEmailDomainDMARCRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    return o;
}
export function verifyEmailDomainDMARCRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
    };
}
export function verifyEmailDomainDMARCResponseToJson(m) {
    const o = {};
    if (m.dmarcPass !== undefined)
        o['dmarcPass'] = m.dmarcPass;
    if (m.dmarcRecord !== undefined)
        o['dmarcRecord'] = m.dmarcRecord;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    return o;
}
export function verifyEmailDomainDMARCResponseFromJson(o) {
    var _a, _b, _c;
    return {
        dmarcPass: (_a = o['dmarcPass']) !== null && _a !== void 0 ? _a : false,
        dmarcRecord: (_b = o['dmarcRecord']) !== null && _b !== void 0 ? _b : '',
        reason: (_c = o['reason']) !== null && _c !== void 0 ? _c : '',
    };
}
export function deleteEmailDomainRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function deleteEmailDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function changeEmailDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.sendFromDomain !== undefined)
        o['sendFromDomain'] = m.sendFromDomain;
    if (m.sendFromUsername !== undefined)
        o['sendFromUsername'] = m.sendFromUsername;
    if (m.replyToEmail !== undefined)
        o['replyToEmail'] = m.replyToEmail;
    if (m.sendFromName !== undefined)
        o['sendFromName'] = m.sendFromName;
    return o;
}
export function changeEmailDomainRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        sendFromDomain: (_c = o['sendFromDomain']) !== null && _c !== void 0 ? _c : '',
        sendFromUsername: (_d = o['sendFromUsername']) !== null && _d !== void 0 ? _d : '',
        replyToEmail: (_e = o['replyToEmail']) !== null && _e !== void 0 ? _e : '',
        sendFromName: (_f = o['sendFromName']) !== null && _f !== void 0 ? _f : '',
    };
}
export function changeEmailDomainResponseToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function changeEmailDomainResponseFromJson(o) {
    var _a;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'CHANGE_EMAIL_DOMAIN_STATUS_INVALID',
    };
}
export function getPendingEmailDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function getPendingEmailDomainRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPendingEmailDomainTargetCNameRecordsToJson(m) {
    const o = {};
    if (m.mailSubdomain !== undefined)
        o['mailSubdomain'] = m.mailSubdomain;
    if (m.mailValue !== undefined)
        o['mailValue'] = m.mailValue;
    if (m.dkim1Subdomain !== undefined)
        o['dkim1Subdomain'] = m.dkim1Subdomain;
    if (m.dkim1Value !== undefined)
        o['dkim1Value'] = m.dkim1Value;
    if (m.dkim2Subdomain !== undefined)
        o['dkim2Subdomain'] = m.dkim2Subdomain;
    if (m.dkim2Value !== undefined)
        o['dkim2Value'] = m.dkim2Value;
    if (m.dmarcSubdomain !== undefined)
        o['dmarcSubdomain'] = m.dmarcSubdomain;
    if (m.dmarcValue !== undefined)
        o['dmarcValue'] = m.dmarcValue;
    return o;
}
export function getPendingEmailDomainTargetCNameRecordsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        mailSubdomain: (_a = o['mailSubdomain']) !== null && _a !== void 0 ? _a : '',
        mailValue: (_b = o['mailValue']) !== null && _b !== void 0 ? _b : '',
        dkim1Subdomain: (_c = o['dkim1Subdomain']) !== null && _c !== void 0 ? _c : '',
        dkim1Value: (_d = o['dkim1Value']) !== null && _d !== void 0 ? _d : '',
        dkim2Subdomain: (_e = o['dkim2Subdomain']) !== null && _e !== void 0 ? _e : '',
        dkim2Value: (_f = o['dkim2Value']) !== null && _f !== void 0 ? _f : '',
        dmarcSubdomain: (_g = o['dmarcSubdomain']) !== null && _g !== void 0 ? _g : '',
        dmarcValue: (_h = o['dmarcValue']) !== null && _h !== void 0 ? _h : '',
    };
}
export function getPendingEmailDomainResponseToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.sendFromDomain !== undefined)
        o['sendFromDomain'] = m.sendFromDomain;
    if (m.targetSpf !== undefined)
        o['targetSpf'] = m.targetSpf;
    if (m.currentSpf !== undefined)
        o['currentSpf'] = m.currentSpf;
    if (m.sendFromUsername !== undefined)
        o['sendFromUsername'] = m.sendFromUsername;
    if (m.targets !== undefined)
        o['targets'] = getPendingEmailDomainTargetCNameRecordsToJson(m.targets);
    if (m.typeChangeConfirmationRequired !== undefined)
        o['typeChangeConfirmationRequired'] = m.typeChangeConfirmationRequired;
    return o;
}
export function getPendingEmailDomainResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        sendFromDomain: (_c = o['sendFromDomain']) !== null && _c !== void 0 ? _c : '',
        targetSpf: (_d = o['targetSpf']) !== null && _d !== void 0 ? _d : '',
        currentSpf: (_e = o['currentSpf']) !== null && _e !== void 0 ? _e : '',
        sendFromUsername: (_f = o['sendFromUsername']) !== null && _f !== void 0 ? _f : '',
        targets: o['targets'] ? getPendingEmailDomainTargetCNameRecordsFromJson(o['targets']) : undefined,
        typeChangeConfirmationRequired: (_g = o['typeChangeConfirmationRequired']) !== null && _g !== void 0 ? _g : false,
    };
}
export function verifyPendingEmailDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function verifyPendingEmailDomainRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function verifyPendingEmailDomainMismatchToJson(m) {
    const o = {};
    if (m.dnsRecordType !== undefined)
        o['dnsRecordType'] = m.dnsRecordType;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.expectedValue !== undefined)
        o['expectedValue'] = m.expectedValue;
    if (m.actualValue !== undefined)
        o['actualValue'] = m.actualValue;
    if (m.matchedPrefix !== undefined)
        o['matchedPrefix'] = m.matchedPrefix;
    if (m.matchedSuffix !== undefined)
        o['matchedSuffix'] = m.matchedSuffix;
    return o;
}
export function verifyPendingEmailDomainMismatchFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        dnsRecordType: (_a = o['dnsRecordType']) !== null && _a !== void 0 ? _a : '',
        url: (_b = o['url']) !== null && _b !== void 0 ? _b : '',
        expectedValue: (_c = o['expectedValue']) !== null && _c !== void 0 ? _c : '',
        actualValue: (_d = o['actualValue']) !== null && _d !== void 0 ? _d : '',
        matchedPrefix: (_e = o['matchedPrefix']) !== null && _e !== void 0 ? _e : '',
        matchedSuffix: (_f = o['matchedSuffix']) !== null && _f !== void 0 ? _f : '',
    };
}
export function verifyPendingEmailDomainResponseToJson(m) {
    const o = {};
    if (m.allRecordsMatch !== undefined)
        o['allRecordsMatch'] = m.allRecordsMatch;
    if (m.mismatches !== undefined) {
        o['mismatches'] = m.mismatches.map(e => verifyPendingEmailDomainMismatchToJson(e));
    }
    return o;
}
export function verifyPendingEmailDomainResponseFromJson(o) {
    var _a, _b;
    return {
        allRecordsMatch: (_a = o['allRecordsMatch']) !== null && _a !== void 0 ? _a : false,
        mismatches: ((_b = o['mismatches']) !== null && _b !== void 0 ? _b : []).map(e => verifyPendingEmailDomainMismatchFromJson(e)),
    };
}
export function deletePendingEmailDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    return o;
}
export function deletePendingEmailDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        domain: (_c = o['domain']) !== null && _c !== void 0 ? _c : '',
    };
}
export function sendWhitelabelEmailToUserRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipientUser !== undefined)
        o['recipientUser'] = userParticipantToJson(m.recipientUser);
    if (m.message !== undefined)
        o['message'] = whiteLabelEmailMessageToJson(m.message);
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.transactional !== undefined)
        o['transactional'] = m.transactional;
    if (m.recipient !== undefined) {
        if (m.recipient.type === 'userParticipant') {
            o['userParticipant'] = userParticipantToJson(m.recipient.userParticipant);
        }
        if (m.recipient.type === 'contactParticipant') {
            o['contactParticipant'] = contactParticipantToJson(m.recipient.contactParticipant);
        }
    }
    else {
        if (m.userParticipant !== undefined)
            o['userParticipant'] = userParticipantToJson(m.userParticipant);
        if (m.contactParticipant !== undefined)
            o['contactParticipant'] = contactParticipantToJson(m.contactParticipant);
    }
    return o;
}
export function sendWhitelabelEmailToUserRequestFromJson(o) {
    var _a, _b;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipientUser: o['recipientUser'] ? userParticipantFromJson(o['recipientUser']) : undefined,
        message: o['message'] ? whiteLabelEmailMessageFromJson(o['message']) : undefined,
        idempotencyKey: (_a = o['idempotencyKey']) !== null && _a !== void 0 ? _a : '',
        transactional: (_b = o['transactional']) !== null && _b !== void 0 ? _b : false,
        recipient: (() => {
            if (o['userParticipant'] !== undefined)
                return { type: 'userParticipant', userParticipant: o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined };
            if (o['contactParticipant'] !== undefined)
                return { type: 'contactParticipant', contactParticipant: o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined };
            return undefined;
        })(),
        userParticipant: o['userParticipant'] !== undefined ? o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined : undefined,
        contactParticipant: o['contactParticipant'] !== undefined ? o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined : undefined,
    };
}
export function sendWhitelabelEmailToUserResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendWhitelabelEmailToUserResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendFromAuthorizedDomainRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipient !== undefined)
        o['recipient'] = participantToJson(m.recipient);
    if (m.message !== undefined)
        o['message'] = whiteLabelEmailMessageToJson(m.message);
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.transactional !== undefined)
        o['transactional'] = m.transactional;
    if (m.encryptContentAtRest !== undefined)
        o['encryptContentAtRest'] = m.encryptContentAtRest;
    if (m.customSender !== undefined)
        o['customSender'] = customSenderToJson(m.customSender);
    if (m.inboundMessageMappingOptions !== undefined)
        o['inboundMessageMappingOptions'] = inboundMessageMappingOptionsToJson(m.inboundMessageMappingOptions);
    return o;
}
export function sendFromAuthorizedDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipient: o['recipient'] ? participantFromJson(o['recipient']) : undefined,
        message: o['message'] ? whiteLabelEmailMessageFromJson(o['message']) : undefined,
        idempotencyKey: (_a = o['idempotencyKey']) !== null && _a !== void 0 ? _a : '',
        transactional: (_b = o['transactional']) !== null && _b !== void 0 ? _b : false,
        encryptContentAtRest: (_c = o['encryptContentAtRest']) !== null && _c !== void 0 ? _c : false,
        customSender: o['customSender'] ? customSenderFromJson(o['customSender']) : undefined,
        inboundMessageMappingOptions: o['inboundMessageMappingOptions'] ? inboundMessageMappingOptionsFromJson(o['inboundMessageMappingOptions']) : undefined,
    };
}
export function sendFromAuthorizedDomainResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendFromAuthorizedDomainResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sourceInfoToJson(m) {
    const o = {};
    if (m.sourceName !== undefined)
        o['sourceName'] = m.sourceName;
    if (m.sourceDrillDown1 !== undefined)
        o['sourceDrillDown1'] = m.sourceDrillDown1;
    if (m.sourceDrillDown2 !== undefined)
        o['sourceDrillDown2'] = m.sourceDrillDown2;
    return o;
}
export function sourceInfoFromJson(o) {
    var _a, _b, _c;
    return {
        sourceName: (_a = o['sourceName']) !== null && _a !== void 0 ? _a : '',
        sourceDrillDown1: (_b = o['sourceDrillDown1']) !== null && _b !== void 0 ? _b : '',
        sourceDrillDown2: (_c = o['sourceDrillDown2']) !== null && _c !== void 0 ? _c : '',
    };
}
export function sendFromProviderRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.provider !== undefined)
        o['provider'] = m.provider;
    if (m.message !== undefined)
        o['message'] = whiteLabelEmailMessageToJson(m.message);
    if (m.providerMessageThreadId !== undefined)
        o['providerMessageThreadId'] = m.providerMessageThreadId;
    if (m.sendAsDraft !== undefined)
        o['sendAsDraft'] = m.sendAsDraft;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.visibility !== undefined)
        o['visibility'] = m.visibility;
    if (m.sourceInfo !== undefined)
        o['sourceInfo'] = sourceInfoToJson(m.sourceInfo);
    if (m.fromConnectionId !== undefined)
        o['fromConnectionId'] = m.fromConnectionId;
    if (m.additionalAssociations !== undefined) {
        o['additionalAssociations'] = m.additionalAssociations.map(e => sendFromProviderRequestCrmObjectAssociationToJson(e));
    }
    if (m.toRecipients !== undefined) {
        o['toRecipients'] = m.toRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.ccRecipients !== undefined) {
        o['ccRecipients'] = m.ccRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.bccRecipients !== undefined) {
        o['bccRecipients'] = m.bccRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.inReplyToMessageId !== undefined)
        o['inReplyToMessageId'] = m.inReplyToMessageId;
    if (m.autoPopulateRecipientsFromThread !== undefined)
        o['autoPopulateRecipientsFromThread'] = m.autoPopulateRecipientsFromThread;
    if (m.fromDraftTrackedMessageId !== undefined)
        o['fromDraftTrackedMessageId'] = m.fromDraftTrackedMessageId;
    if (m.recipient !== undefined) {
        if (m.recipient.type === 'userParticipant') {
            o['userParticipant'] = userParticipantToJson(m.recipient.userParticipant);
        }
        if (m.recipient.type === 'contactParticipant') {
            o['contactParticipant'] = contactParticipantToJson(m.recipient.contactParticipant);
        }
    }
    else {
        if (m.userParticipant !== undefined)
            o['userParticipant'] = userParticipantToJson(m.userParticipant);
        if (m.contactParticipant !== undefined)
            o['contactParticipant'] = contactParticipantToJson(m.contactParticipant);
    }
    return o;
}
export function sendFromProviderRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        provider: (_b = o['provider']) !== null && _b !== void 0 ? _b : 'PROVIDER_INVALID',
        message: o['message'] ? whiteLabelEmailMessageFromJson(o['message']) : undefined,
        providerMessageThreadId: (_c = o['providerMessageThreadId']) !== null && _c !== void 0 ? _c : '',
        sendAsDraft: (_d = o['sendAsDraft']) !== null && _d !== void 0 ? _d : false,
        idempotencyKey: (_e = o['idempotencyKey']) !== null && _e !== void 0 ? _e : '',
        visibility: (_f = o['visibility']) !== null && _f !== void 0 ? _f : 'VISIBILITY_INVALID',
        sourceInfo: o['sourceInfo'] ? sourceInfoFromJson(o['sourceInfo']) : undefined,
        fromConnectionId: (_g = o['fromConnectionId']) !== null && _g !== void 0 ? _g : '',
        additionalAssociations: ((_h = o['additionalAssociations']) !== null && _h !== void 0 ? _h : []).map(e => sendFromProviderRequestCrmObjectAssociationFromJson(e)),
        toRecipients: ((_j = o['toRecipients']) !== null && _j !== void 0 ? _j : []).map(e => emailRecipientFromJson(e)),
        ccRecipients: ((_k = o['ccRecipients']) !== null && _k !== void 0 ? _k : []).map(e => emailRecipientFromJson(e)),
        bccRecipients: ((_l = o['bccRecipients']) !== null && _l !== void 0 ? _l : []).map(e => emailRecipientFromJson(e)),
        inReplyToMessageId: (_m = o['inReplyToMessageId']) !== null && _m !== void 0 ? _m : '',
        autoPopulateRecipientsFromThread: (_o = o['autoPopulateRecipientsFromThread']) !== null && _o !== void 0 ? _o : false,
        fromDraftTrackedMessageId: (_p = o['fromDraftTrackedMessageId']) !== null && _p !== void 0 ? _p : '',
        recipient: (() => {
            if (o['userParticipant'] !== undefined)
                return { type: 'userParticipant', userParticipant: o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined };
            if (o['contactParticipant'] !== undefined)
                return { type: 'contactParticipant', contactParticipant: o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined };
            return undefined;
        })(),
        userParticipant: o['userParticipant'] !== undefined ? o['userParticipant'] ? userParticipantFromJson(o['userParticipant']) : undefined : undefined,
        contactParticipant: o['contactParticipant'] !== undefined ? o['contactParticipant'] ? contactParticipantFromJson(o['contactParticipant']) : undefined : undefined,
    };
}
export function sendFromProviderRequestCrmObjectAssociationToJson(m) {
    const o = {};
    if (m.crmObjectId !== undefined)
        o['crmObjectId'] = m.crmObjectId;
    if (m.crmObjectType !== undefined)
        o['crmObjectType'] = m.crmObjectType;
    if (m.crmObjectSubtype !== undefined)
        o['crmObjectSubtype'] = m.crmObjectSubtype;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function sendFromProviderRequestCrmObjectAssociationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        crmObjectId: (_a = o['crmObjectId']) !== null && _a !== void 0 ? _a : '',
        crmObjectType: (_b = o['crmObjectType']) !== null && _b !== void 0 ? _b : '',
        crmObjectSubtype: (_c = o['crmObjectSubtype']) !== null && _c !== void 0 ? _c : '',
        tags: ((_d = o['tags']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function sendFromProviderResponseToJson(m) {
    const o = {};
    return o;
}
export function sendFromProviderResponseFromJson(o) {
    return {};
}
export function sendPreviewEmailUsingEmailBuilderRequestToJson(m) {
    const o = {};
    if (m.emailBuilderEmailId !== undefined)
        o['emailBuilderEmailId'] = m.emailBuilderEmailId;
    if (m.previewContact !== undefined)
        o['previewContact'] = contactParticipantToJson(m.previewContact);
    if (m.recipient !== undefined)
        o['recipient'] = userParticipantToJson(m.recipient);
    return o;
}
export function sendPreviewEmailUsingEmailBuilderRequestFromJson(o) {
    var _a;
    return {
        emailBuilderEmailId: (_a = o['emailBuilderEmailId']) !== null && _a !== void 0 ? _a : '',
        previewContact: o['previewContact'] ? contactParticipantFromJson(o['previewContact']) : undefined,
        recipient: o['recipient'] ? userParticipantFromJson(o['recipient']) : undefined,
    };
}
export function sendPreviewEmailUsingEmailBuilderResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendPreviewEmailUsingEmailBuilderResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function sendEmailUsingEmailBuilderRequestToJson(m) {
    const o = {};
    if (m.emailBuilderEmailId !== undefined)
        o['emailBuilderEmailId'] = m.emailBuilderEmailId;
    if (m.contact !== undefined)
        o['contact'] = contactParticipantToJson(m.contact);
    if (m.customSender !== undefined)
        o['customSender'] = customSenderToJson(m.customSender);
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    return o;
}
export function sendEmailUsingEmailBuilderRequestFromJson(o) {
    var _a, _b, _c;
    return {
        emailBuilderEmailId: (_a = o['emailBuilderEmailId']) !== null && _a !== void 0 ? _a : '',
        contact: o['contact'] ? contactParticipantFromJson(o['contact']) : undefined,
        customSender: o['customSender'] ? customSenderFromJson(o['customSender']) : undefined,
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        attributes: ((_b = o['attributes']) !== null && _b !== void 0 ? _b : []).map(e => attributeFromJson(e)),
        idempotencyKey: (_c = o['idempotencyKey']) !== null && _c !== void 0 ? _c : '',
    };
}
export function sendEmailUsingEmailBuilderResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function sendEmailUsingEmailBuilderResponseFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function verifyDefaultDomainRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    return o;
}
export function verifyDefaultDomainRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
    };
}
export function verifyDefaultDomainMismatchToJson(m) {
    const o = {};
    if (m.dnsRecordType !== undefined)
        o['dnsRecordType'] = m.dnsRecordType;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.expectedValue !== undefined)
        o['expectedValue'] = m.expectedValue;
    if (m.actualValue !== undefined)
        o['actualValue'] = m.actualValue;
    if (m.matchedPrefix !== undefined)
        o['matchedPrefix'] = m.matchedPrefix;
    if (m.matchedSuffix !== undefined)
        o['matchedSuffix'] = m.matchedSuffix;
    return o;
}
export function verifyDefaultDomainMismatchFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        dnsRecordType: (_a = o['dnsRecordType']) !== null && _a !== void 0 ? _a : '',
        url: (_b = o['url']) !== null && _b !== void 0 ? _b : '',
        expectedValue: (_c = o['expectedValue']) !== null && _c !== void 0 ? _c : '',
        actualValue: (_d = o['actualValue']) !== null && _d !== void 0 ? _d : '',
        matchedPrefix: (_e = o['matchedPrefix']) !== null && _e !== void 0 ? _e : '',
        matchedSuffix: (_f = o['matchedSuffix']) !== null && _f !== void 0 ? _f : '',
    };
}
export function verifyDefaultDomainResponseToJson(m) {
    const o = {};
    if (m.allRecordsMatch !== undefined)
        o['allRecordsMatch'] = m.allRecordsMatch;
    if (m.mismatches !== undefined) {
        o['mismatches'] = m.mismatches.map(e => verifyDefaultDomainMismatchToJson(e));
    }
    return o;
}
export function verifyDefaultDomainResponseFromJson(o) {
    var _a, _b;
    return {
        allRecordsMatch: (_a = o['allRecordsMatch']) !== null && _a !== void 0 ? _a : false,
        mismatches: ((_b = o['mismatches']) !== null && _b !== void 0 ? _b : []).map(e => verifyDefaultDomainMismatchFromJson(e)),
    };
}
export function createPendingDomainRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.domainType !== undefined)
        o['domainType'] = m.domainType;
    if (m.confirmedTypeChange !== undefined)
        o['confirmedTypeChange'] = m.confirmedTypeChange;
    return o;
}
export function createPendingDomainRequestFromJson(o) {
    var _a, _b, _c;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        domain: (_a = o['domain']) !== null && _a !== void 0 ? _a : '',
        domainType: (_b = o['domainType']) !== null && _b !== void 0 ? _b : 'DOMAIN_TYPE_DEDICATED',
        confirmedTypeChange: (_c = o['confirmedTypeChange']) !== null && _c !== void 0 ? _c : false,
    };
}
export function listAllDomainsRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    return o;
}
export function listAllDomainsRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
    };
}
export function listAllDomainsResponseToJson(m) {
    const o = {};
    if (m.domains !== undefined) {
        o['domains'] = m.domains.map(e => senderDomainToJson(e));
    }
    return o;
}
export function listAllDomainsResponseFromJson(o) {
    var _a;
    return {
        domains: ((_a = o['domains']) !== null && _a !== void 0 ? _a : []).map(e => senderDomainFromJson(e)),
    };
}
export function getDefaultDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    return o;
}
export function getDefaultDomainRequestFromJson(o) {
    var _a;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
    };
}
export function getDefaultDomainResponseToJson(m) {
    const o = {};
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    return o;
}
export function getDefaultDomainResponseFromJson(o) {
    var _a;
    return {
        domain: (_a = o['domain']) !== null && _a !== void 0 ? _a : '',
    };
}
export function senderDomainToJson(m) {
    const o = {};
    if (m.sendFromDomain !== undefined)
        o['sendFromDomain'] = m.sendFromDomain;
    if (m.targetSpf !== undefined)
        o['targetSpf'] = m.targetSpf;
    if (m.currentSpf !== undefined)
        o['currentSpf'] = m.currentSpf;
    if (m.targets !== undefined)
        o['targets'] = getPendingEmailDomainTargetCNameRecordsToJson(m.targets);
    if (m.isPrimary !== undefined)
        o['isPrimary'] = m.isPrimary;
    return o;
}
export function senderDomainFromJson(o) {
    var _a, _b, _c, _d;
    return {
        sendFromDomain: (_a = o['sendFromDomain']) !== null && _a !== void 0 ? _a : '',
        targetSpf: (_b = o['targetSpf']) !== null && _b !== void 0 ? _b : '',
        currentSpf: (_c = o['currentSpf']) !== null && _c !== void 0 ? _c : '',
        targets: o['targets'] ? getPendingEmailDomainTargetCNameRecordsFromJson(o['targets']) : undefined,
        isPrimary: (_d = o['isPrimary']) !== null && _d !== void 0 ? _d : false,
    };
}
export function quarantineSenderRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function quarantineSenderRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSenderInfoRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    return o;
}
export function getSenderInfoRequestFromJson(o) {
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
    };
}
export function getSenderInfoResponseToJson(m) {
    const o = {};
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.isPlatformAuthorized !== undefined)
        o['isPlatformAuthorized'] = m.isPlatformAuthorized;
    if (m.isDefaultForSenderType !== undefined)
        o['isDefaultForSenderType'] = m.isDefaultForSenderType;
    if (m.preferredEmailUsername !== undefined)
        o['preferredEmailUsername'] = m.preferredEmailUsername;
    if (m.preferredEmailDisplayName !== undefined)
        o['preferredEmailDisplayName'] = m.preferredEmailDisplayName;
    if (m.preferredReplyToEmailAddress !== undefined)
        o['preferredReplyToEmailAddress'] = m.preferredReplyToEmailAddress;
    return o;
}
export function getSenderInfoResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        domain: (_a = o['domain']) !== null && _a !== void 0 ? _a : '',
        isPlatformAuthorized: (_b = o['isPlatformAuthorized']) !== null && _b !== void 0 ? _b : false,
        isDefaultForSenderType: (_c = o['isDefaultForSenderType']) !== null && _c !== void 0 ? _c : false,
        preferredEmailUsername: (_d = o['preferredEmailUsername']) !== null && _d !== void 0 ? _d : '',
        preferredEmailDisplayName: (_e = o['preferredEmailDisplayName']) !== null && _e !== void 0 ? _e : '',
        preferredReplyToEmailAddress: (_f = o['preferredReplyToEmailAddress']) !== null && _f !== void 0 ? _f : '',
    };
}
export function upsertPartnerEmailQuotaRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.dailyQuota !== undefined)
        o['dailyQuota'] = m.dailyQuota;
    return o;
}
export function upsertPartnerEmailQuotaRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        dailyQuota: (_b = o['dailyQuota']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function partnerEmailQuotaMutationToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.dailyQuota !== undefined)
        o['dailyQuota'] = m.dailyQuota;
    return o;
}
export function partnerEmailQuotaMutationFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        dailyQuota: (_b = o['dailyQuota']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function bulkUpsertPartnerEmailQuotaRequestToJson(m) {
    const o = {};
    if (m.partnerEmailQuota !== undefined) {
        o['partnerEmailQuota'] = m.partnerEmailQuota.map(e => partnerEmailQuotaMutationToJson(e));
    }
    return o;
}
export function bulkUpsertPartnerEmailQuotaRequestFromJson(o) {
    var _a;
    return {
        partnerEmailQuota: ((_a = o['partnerEmailQuota']) !== null && _a !== void 0 ? _a : []).map(e => partnerEmailQuotaMutationFromJson(e)),
    };
}
export function deletePartnerEmailQuotaRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function deletePartnerEmailQuotaRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiPartnerEmailQuotaRequestToJson(m) {
    const o = {};
    if (m.partnerIds !== undefined) {
        o['partnerIds'] = m.partnerIds.map(e => e);
    }
    return o;
}
export function getMultiPartnerEmailQuotaRequestFromJson(o) {
    var _a;
    return {
        partnerIds: ((_a = o['partnerIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiPartnerEmailQuotaResponseToJson(m) {
    const o = {};
    if (m.partnerEmailQuotas !== undefined) {
        o['partnerEmailQuotas'] = m.partnerEmailQuotas.map(e => partnerEmailQuotaToJson(e));
    }
    return o;
}
export function getMultiPartnerEmailQuotaResponseFromJson(o) {
    var _a;
    return {
        partnerEmailQuotas: ((_a = o['partnerEmailQuotas']) !== null && _a !== void 0 ? _a : []).map(e => partnerEmailQuotaFromJson(e)),
    };
}
export function listSendGridTeammatesRequestToJson(m) {
    const o = {};
    return o;
}
export function listSendGridTeammatesRequestFromJson(o) {
    return {};
}
export function sendGridTeammateToJson(m) {
    const o = {};
    if (m.fullName !== undefined)
        o['fullName'] = m.fullName;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.role !== undefined)
        o['role'] = m.role;
    if (m.slackUserName !== undefined)
        o['slackUserName'] = m.slackUserName;
    if (m.slackUrl !== undefined)
        o['slackUrl'] = m.slackUrl;
    return o;
}
export function sendGridTeammateFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        fullName: (_a = o['fullName']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
        role: (_c = o['role']) !== null && _c !== void 0 ? _c : '',
        slackUserName: (_d = o['slackUserName']) !== null && _d !== void 0 ? _d : '',
        slackUrl: (_e = o['slackUrl']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listSendGridTeammatesResponseToJson(m) {
    const o = {};
    if (m.teammates !== undefined) {
        o['teammates'] = m.teammates.map(e => sendGridTeammateToJson(e));
    }
    return o;
}
export function listSendGridTeammatesResponseFromJson(o) {
    var _a;
    return {
        teammates: ((_a = o['teammates']) !== null && _a !== void 0 ? _a : []).map(e => sendGridTeammateFromJson(e)),
    };
}
export function listSendGridSubUserReputationsRequestToJson(m) {
    const o = {};
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    return o;
}
export function listSendGridSubUserReputationsRequestFromJson(o) {
    var _a, _b;
    return {
        pageSize: (_a = o['pageSize']) !== null && _a !== void 0 ? _a : 0,
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function sendGridSubUserReputationToJson(m) {
    const o = {};
    if (m.username !== undefined)
        o['username'] = m.username;
    if (m.reputationPercent !== undefined)
        o['reputationPercent'] = m.reputationPercent;
    return o;
}
export function sendGridSubUserReputationFromJson(o) {
    var _a, _b;
    return {
        username: (_a = o['username']) !== null && _a !== void 0 ? _a : '',
        reputationPercent: (_b = o['reputationPercent']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function listSendGridSubUserReputationsResponseToJson(m) {
    const o = {};
    if (m.reputations !== undefined) {
        o['reputations'] = m.reputations.map(e => sendGridSubUserReputationToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    return o;
}
export function listSendGridSubUserReputationsResponseFromJson(o) {
    var _a, _b;
    return {
        reputations: ((_a = o['reputations']) !== null && _a !== void 0 ? _a : []).map(e => sendGridSubUserReputationFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function getSenderReputationRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function getSenderReputationRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSenderReputationResponseToJson(m) {
    const o = {};
    if (m.reputationPercent !== undefined)
        o['reputationPercent'] = m.reputationPercent;
    if (m.sendgridUsername !== undefined)
        o['sendgridUsername'] = m.sendgridUsername;
    if (m.isSharedSubuser !== undefined)
        o['isSharedSubuser'] = m.isSharedSubuser;
    return o;
}
export function getSenderReputationResponseFromJson(o) {
    var _a, _b, _c;
    return {
        reputationPercent: (_a = o['reputationPercent']) !== null && _a !== void 0 ? _a : 0,
        sendgridUsername: (_b = o['sendgridUsername']) !== null && _b !== void 0 ? _b : '',
        isSharedSubuser: (_c = o['isSharedSubuser']) !== null && _c !== void 0 ? _c : false,
    };
}
export function adminSetEmailQueuesStatusRequestToJson(m) {
    const o = {};
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function adminSetEmailQueuesStatusRequestFromJson(o) {
    var _a;
    return {
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'EMAIL_QUEUE_STATUS_UNSPECIFIED',
    };
}
export function redirectEmailRequestToJson(m) {
    const o = {};
    if (m.authCheckOnly !== undefined)
        o['authCheckOnly'] = m.authCheckOnly;
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.newRecipientEmailAddress !== undefined)
        o['newRecipientEmailAddress'] = m.newRecipientEmailAddress;
    if (m.includeContent !== undefined)
        o['includeContent'] = m.includeContent;
    if (m.includeAttributes !== undefined)
        o['includeAttributes'] = m.includeAttributes;
    if (m.override !== undefined)
        o['override'] = emailMessageToJson(m.override);
    if (m.overrideSender !== undefined)
        o['overrideSender'] = senderToJson(m.overrideSender);
    return o;
}
export function redirectEmailRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        authCheckOnly: (_a = o['authCheckOnly']) !== null && _a !== void 0 ? _a : false,
        emailId: (_b = o['emailId']) !== null && _b !== void 0 ? _b : '',
        newRecipientEmailAddress: (_c = o['newRecipientEmailAddress']) !== null && _c !== void 0 ? _c : '',
        includeContent: (_d = o['includeContent']) !== null && _d !== void 0 ? _d : false,
        includeAttributes: (_e = o['includeAttributes']) !== null && _e !== void 0 ? _e : false,
        override: o['override'] ? emailMessageFromJson(o['override']) : undefined,
        overrideSender: o['overrideSender'] ? senderFromJson(o['overrideSender']) : undefined,
    };
}
export function redirectEmailResponseToJson(m) {
    const o = {};
    if (m.newEmailId !== undefined)
        o['newEmailId'] = m.newEmailId;
    return o;
}
export function redirectEmailResponseFromJson(o) {
    var _a;
    return {
        newEmailId: (_a = o['newEmailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getUnsubscribedRecipientRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedDomain !== undefined)
        o['unsubscribedDomain'] = m.unsubscribedDomain;
    return o;
}
export function getUnsubscribedRecipientRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        recipientEmail: (_c = o['recipientEmail']) !== null && _c !== void 0 ? _c : '',
        unsubscribedDomain: (_d = o['unsubscribedDomain']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getUnsubscribedRecipientResponseToJson(m) {
    const o = {};
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    return o;
}
export function getUnsubscribedRecipientResponseFromJson(o) {
    var _a, _b;
    return {
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
        unsubscribedGroups: ((_b = o['unsubscribedGroups']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function resubscribeRecipientRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedDomain !== undefined)
        o['unsubscribedDomain'] = m.unsubscribedDomain;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    return o;
}
export function resubscribeRecipientRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        recipientEmail: (_c = o['recipientEmail']) !== null && _c !== void 0 ? _c : '',
        unsubscribedDomain: (_d = o['unsubscribedDomain']) !== null && _d !== void 0 ? _d : '',
        unsubscribedGroups: ((_e = o['unsubscribedGroups']) !== null && _e !== void 0 ? _e : []).map(e => e),
    };
}
export function listUnsubscribedRecipientsRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.paging !== undefined)
        o['paging'] = vendastatypesPagedRequestOptionsToJson(m.paging);
    return o;
}
export function listUnsubscribedRecipientsRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        paging: o['paging'] ? vendastatypesPagedRequestOptionsFromJson(o['paging']) : undefined,
    };
}
export function unsubscribedRecipientToJson(m) {
    const o = {};
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.unsubscribeType !== undefined)
        o['unsubscribeType'] = m.unsubscribeType;
    if (m.unsubscribedDomain !== undefined)
        o['unsubscribedDomain'] = m.unsubscribedDomain;
    return o;
}
export function unsubscribedRecipientFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
        unsubscribedGroups: ((_b = o['unsubscribedGroups']) !== null && _b !== void 0 ? _b : []).map(e => e),
        senderType: (_c = o['senderType']) !== null && _c !== void 0 ? _c : 'SENDER_TYPE_INVALID',
        senderId: (_d = o['senderId']) !== null && _d !== void 0 ? _d : '',
        unsubscribeType: (_e = o['unsubscribeType']) !== null && _e !== void 0 ? _e : '',
        unsubscribedDomain: (_f = o['unsubscribedDomain']) !== null && _f !== void 0 ? _f : '',
    };
}
export function listUnsubscribedRecipientsResponseToJson(m) {
    const o = {};
    if (m.unsubscribedRecipients !== undefined) {
        o['unsubscribedRecipients'] = m.unsubscribedRecipients.map(e => unsubscribedRecipientToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = vendastatypesPagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listUnsubscribedRecipientsResponseFromJson(o) {
    var _a;
    return {
        unsubscribedRecipients: ((_a = o['unsubscribedRecipients']) !== null && _a !== void 0 ? _a : []).map(e => unsubscribedRecipientFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? vendastatypesPagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function initiateEmailDomainRollbackRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function initiateEmailDomainRollbackRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function initiateEmailDomainRectifyRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.bypassFrequencyLimit !== undefined)
        o['bypassFrequencyLimit'] = m.bypassFrequencyLimit;
    return o;
}
export function initiateEmailDomainRectifyRequestFromJson(o) {
    var _a, _b, _c;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        bypassFrequencyLimit: (_c = o['bypassFrequencyLimit']) !== null && _c !== void 0 ? _c : false,
    };
}
export function categoryToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    return o;
}
export function categoryFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : 'NAMESPACE_INVALID',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getCategoriesRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function getCategoriesRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getCategoriesResponseToJson(m) {
    const o = {};
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => categoryToJson(e));
    }
    return o;
}
export function getCategoriesResponseFromJson(o) {
    var _a;
    return {
        categories: ((_a = o['categories']) !== null && _a !== void 0 ? _a : []).map(e => categoryFromJson(e)),
    };
}
export function getCategoryPreferencesRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientId !== undefined)
        o['recipientId'] = m.recipientId;
    return o;
}
export function getCategoryPreferencesRequestFromJson(o) {
    var _a, _b, _c;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        recipientId: (_c = o['recipientId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getCategoryPreferencesResponseToJson(m) {
    const o = {};
    if (m.optedInEmailCategoryIds !== undefined) {
        o['optedInEmailCategoryIds'] = m.optedInEmailCategoryIds.map(e => e);
    }
    if (m.emailPreferenceInitialized !== undefined)
        o['emailPreferenceInitialized'] = m.emailPreferenceInitialized;
    return o;
}
export function getCategoryPreferencesResponseFromJson(o) {
    var _a, _b;
    return {
        optedInEmailCategoryIds: ((_a = o['optedInEmailCategoryIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        emailPreferenceInitialized: (_b = o['emailPreferenceInitialized']) !== null && _b !== void 0 ? _b : false,
    };
}
export function saveCategoryPreferencesRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.optedInEmailCategoryIds !== undefined) {
        o['optedInEmailCategoryIds'] = m.optedInEmailCategoryIds.map(e => e);
    }
    if (m.recipientId !== undefined) {
        if (m.recipientId.type === 'unverifiedEmailAddress') {
            o['unverifiedEmailAddress'] = m.recipientId.unverifiedEmailAddress;
        }
        if (m.recipientId.type === 'userId') {
            o['userId'] = m.recipientId.userId;
        }
    }
    else {
        if (m.unverifiedEmailAddress !== undefined)
            o['unverifiedEmailAddress'] = m.unverifiedEmailAddress;
        if (m.userId !== undefined)
            o['userId'] = m.userId;
    }
    return o;
}
export function saveCategoryPreferencesRequestFromJson(o) {
    var _a, _b, _c;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        optedInEmailCategoryIds: ((_c = o['optedInEmailCategoryIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
        recipientId: (() => {
            if (o['unverifiedEmailAddress'] !== undefined)
                return { type: 'unverifiedEmailAddress', unverifiedEmailAddress: o['unverifiedEmailAddress'] };
            if (o['userId'] !== undefined)
                return { type: 'userId', userId: o['userId'] };
            return undefined;
        })(),
        unverifiedEmailAddress: o['unverifiedEmailAddress'] !== undefined ? o['unverifiedEmailAddress'] : undefined,
        userId: o['userId'] !== undefined ? o['userId'] : undefined,
    };
}
export function getUnsubscribeLinkRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getUnsubscribeLinkRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getUnsubscribeLinkResponseToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientIds !== undefined) {
        o['recipientIds'] = m.recipientIds.map(e => e);
    }
    return o;
}
export function getUnsubscribeLinkResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
        senderType: (_b = o['senderType']) !== null && _b !== void 0 ? _b : 'SENDER_TYPE_INVALID',
        senderId: (_c = o['senderId']) !== null && _c !== void 0 ? _c : '',
        recipientIds: ((_d = o['recipientIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function bounceSenderToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function bounceSenderFromJson(o) {
    var _a, _b;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'UNBOUNCE_SENDER_TYPE_INVALID',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBouncedRecipientRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = bounceSenderToJson(m.sender);
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    return o;
}
export function getBouncedRecipientRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? bounceSenderFromJson(o['sender']) : undefined,
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getBouncedRecipientResponseToJson(m) {
    const o = {};
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    return o;
}
export function getBouncedRecipientResponseFromJson(o) {
    var _a;
    return {
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function unbounceRecipientRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = bounceSenderToJson(m.sender);
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    return o;
}
export function unbounceRecipientRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? bounceSenderFromJson(o['sender']) : undefined,
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateEmailDomainRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.applicationId !== undefined)
        o['applicationId'] = m.applicationId;
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.mail !== undefined)
        o['mail'] = recordToJson(m.mail);
    if (m.dkim1 !== undefined)
        o['dkim1'] = recordToJson(m.dkim1);
    if (m.dkim2 !== undefined)
        o['dkim2'] = recordToJson(m.dkim2);
    if (m.dmarc !== undefined)
        o['dmarc'] = recordToJson(m.dmarc);
    if (m.subUserId !== undefined)
        o['subUserId'] = m.subUserId;
    if (m.domainId !== undefined)
        o['domainId'] = m.domainId;
    if (m.sendAsEmail !== undefined)
        o['sendAsEmail'] = m.sendAsEmail;
    if (m.sendAsName !== undefined)
        o['sendAsName'] = m.sendAsName;
    if (m.replyToEmail !== undefined)
        o['replyToEmail'] = m.replyToEmail;
    return o;
}
export function updateEmailDomainRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        applicationId: (_b = o['applicationId']) !== null && _b !== void 0 ? _b : '',
        businessId: (_c = o['businessId']) !== null && _c !== void 0 ? _c : '',
        domain: (_d = o['domain']) !== null && _d !== void 0 ? _d : '',
        mail: o['mail'] ? recordFromJson(o['mail']) : undefined,
        dkim1: o['dkim1'] ? recordFromJson(o['dkim1']) : undefined,
        dkim2: o['dkim2'] ? recordFromJson(o['dkim2']) : undefined,
        dmarc: o['dmarc'] ? recordFromJson(o['dmarc']) : undefined,
        subUserId: (_e = o['subUserId']) !== null && _e !== void 0 ? _e : '',
        domainId: (_f = o['domainId']) !== null && _f !== void 0 ? _f : '',
        sendAsEmail: (_g = o['sendAsEmail']) !== null && _g !== void 0 ? _g : '',
        sendAsName: (_h = o['sendAsName']) !== null && _h !== void 0 ? _h : '',
        replyToEmail: (_j = o['replyToEmail']) !== null && _j !== void 0 ? _j : '',
    };
}
export function updatePendingDomainRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.domain !== undefined)
        o['domain'] = m.domain;
    if (m.sendFromUsername !== undefined)
        o['sendFromUsername'] = m.sendFromUsername;
    if (m.targetSpf !== undefined)
        o['targetSpf'] = m.targetSpf;
    if (m.targets !== undefined)
        o['targets'] = getPendingEmailDomainTargetCNameRecordsToJson(m.targets);
    if (m.sendgridSubUserId !== undefined)
        o['sendgridSubUserId'] = m.sendgridSubUserId;
    if (m.sendgridDomainId !== undefined)
        o['sendgridDomainId'] = m.sendgridDomainId;
    if (m.domainType !== undefined)
        o['domainType'] = m.domainType;
    return o;
}
export function updatePendingDomainRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        domain: (_c = o['domain']) !== null && _c !== void 0 ? _c : '',
        sendFromUsername: (_d = o['sendFromUsername']) !== null && _d !== void 0 ? _d : '',
        targetSpf: (_e = o['targetSpf']) !== null && _e !== void 0 ? _e : '',
        targets: o['targets'] ? getPendingEmailDomainTargetCNameRecordsFromJson(o['targets']) : undefined,
        sendgridSubUserId: (_f = o['sendgridSubUserId']) !== null && _f !== void 0 ? _f : '',
        sendgridDomainId: (_g = o['sendgridDomainId']) !== null && _g !== void 0 ? _g : '',
        domainType: (_h = o['domainType']) !== null && _h !== void 0 ? _h : 'DOMAIN_TYPE_DEDICATED',
    };
}
export function initializeSubUserRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function initializeSubUserRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : '',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function deleteSubUserRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    return o;
}
export function deleteSubUserRequestFromJson(o) {
    var _a, _b;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMessageRequestToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function getMessageRequestFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMessageResponseToJson(m) {
    const o = {};
    if (m.message !== undefined)
        o['message'] = emailMessageToJson(m.message);
    return o;
}
export function getMessageResponseFromJson(o) {
    return {
        message: o['message'] ? emailMessageFromJson(o['message']) : undefined,
    };
}
export function getMultiMessageRequestToJson(m) {
    const o = {};
    if (m.emailIds !== undefined) {
        o['emailIds'] = m.emailIds.map(e => e);
    }
    return o;
}
export function getMultiMessageRequestFromJson(o) {
    var _a;
    return {
        emailIds: ((_a = o['emailIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiMessageResponseToJson(m) {
    const o = {};
    if (m.messages !== undefined) {
        o['messages'] = m.messages.map(e => emailMessageToJson(e));
    }
    return o;
}
export function getMultiMessageResponseFromJson(o) {
    var _a;
    return {
        messages: ((_a = o['messages']) !== null && _a !== void 0 ? _a : []).map(e => emailMessageFromJson(e)),
    };
}
export function resubscribeRecipientFromUnsubscribeLinkRequestToJson(m) {
    const o = {};
    if (m.unsubscribeLinkUrl !== undefined)
        o['unsubscribeLinkUrl'] = m.unsubscribeLinkUrl;
    if (m.unsubscribeLinkId !== undefined)
        o['unsubscribeLinkId'] = m.unsubscribeLinkId;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    return o;
}
export function resubscribeRecipientFromUnsubscribeLinkRequestFromJson(o) {
    var _a, _b, _c;
    return {
        unsubscribeLinkUrl: (_a = o['unsubscribeLinkUrl']) !== null && _a !== void 0 ? _a : '',
        unsubscribeLinkId: (_b = o['unsubscribeLinkId']) !== null && _b !== void 0 ? _b : '',
        unsubscribedGroups: ((_c = o['unsubscribedGroups']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function createBlockRequestToJson(m) {
    const o = {};
    if (m.blockType !== undefined)
        o['blockType'] = m.blockType;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.conditions !== undefined)
        o['conditions'] = m.conditions;
    return o;
}
export function createBlockRequestFromJson(o) {
    var _a, _b, _c;
    return {
        blockType: (_a = o['blockType']) !== null && _a !== void 0 ? _a : '',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
        conditions: (_c = o['conditions']) !== null && _c !== void 0 ? _c : '',
    };
}
export function createBlockResponseToJson(m) {
    const o = {};
    if (m.blockType !== undefined)
        o['blockType'] = m.blockType;
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createBlockResponseFromJson(o) {
    var _a, _b;
    return {
        blockType: (_a = o['blockType']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBlockRequestToJson(m) {
    const o = {};
    if (m.blockType !== undefined)
        o['blockType'] = m.blockType;
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getBlockRequestFromJson(o) {
    var _a, _b;
    return {
        blockType: (_a = o['blockType']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getBlockResponseToJson(m) {
    const o = {};
    if (m.blockType !== undefined)
        o['blockType'] = m.blockType;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.conditions !== undefined)
        o['conditions'] = m.conditions;
    return o;
}
export function getBlockResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        blockType: (_a = o['blockType']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        message: (_c = o['message']) !== null && _c !== void 0 ? _c : '',
        conditions: (_d = o['conditions']) !== null && _d !== void 0 ? _d : '',
    };
}
export function deleteBlockRequestToJson(m) {
    const o = {};
    if (m.blockType !== undefined)
        o['blockType'] = m.blockType;
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function deleteBlockRequestFromJson(o) {
    var _a, _b;
    return {
        blockType: (_a = o['blockType']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
    };
}
export function resetRecipientStatusRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    return o;
}
export function resetRecipientStatusRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function batchSearchRecipientStatusRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipientEmails !== undefined) {
        o['recipientEmails'] = m.recipientEmails.map(e => e);
    }
    return o;
}
export function batchSearchRecipientStatusRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipientEmails: ((_a = o['recipientEmails']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function resubscribeRecipientStatusRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    return o;
}
export function resubscribeRecipientStatusRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        recipientEmail: (_c = o['recipientEmail']) !== null && _c !== void 0 ? _c : '',
        unsubscribedGroups: ((_d = o['unsubscribedGroups']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function unsubscribeRecipientStatusRequestToJson(m) {
    const o = {};
    if (m.senderType !== undefined)
        o['senderType'] = m.senderType;
    if (m.senderId !== undefined)
        o['senderId'] = m.senderId;
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    if (m.unsubscribeType !== undefined)
        o['unsubscribeType'] = m.unsubscribeType;
    if (m.unsubscribedDomain !== undefined)
        o['unsubscribedDomain'] = m.unsubscribedDomain;
    return o;
}
export function unsubscribeRecipientStatusRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        senderType: (_a = o['senderType']) !== null && _a !== void 0 ? _a : 'SENDER_TYPE_INVALID',
        senderId: (_b = o['senderId']) !== null && _b !== void 0 ? _b : '',
        recipientEmail: (_c = o['recipientEmail']) !== null && _c !== void 0 ? _c : '',
        unsubscribedGroups: ((_d = o['unsubscribedGroups']) !== null && _d !== void 0 ? _d : []).map(e => e),
        unsubscribeType: (_e = o['unsubscribeType']) !== null && _e !== void 0 ? _e : '',
        unsubscribedDomain: (_f = o['unsubscribedDomain']) !== null && _f !== void 0 ? _f : '',
    };
}
export function batchSearchRecipientStatusResponseToJson(m) {
    const o = {};
    if (m.recipientStatuses !== undefined) {
        o['recipientStatuses'] = m.recipientStatuses.map(e => statusToJson(e));
    }
    return o;
}
export function batchSearchRecipientStatusResponseFromJson(o) {
    var _a;
    return {
        recipientStatuses: ((_a = o['recipientStatuses']) !== null && _a !== void 0 ? _a : []).map(e => statusFromJson(e)),
    };
}
export function statusToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.recipientEmail !== undefined)
        o['recipientEmail'] = m.recipientEmail;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.infractionCount !== undefined)
        o['infractionCount'] = m.infractionCount;
    if (m.bounceExpiry !== undefined)
        o['bounceExpiry'] = m.bounceExpiry.toISOString();
    if (m.lastUpdated !== undefined)
        o['lastUpdated'] = m.lastUpdated.toISOString();
    if (m.unsubscribed !== undefined)
        o['unsubscribed'] = m.unsubscribed;
    if (m.unsubscribedGroups !== undefined) {
        o['unsubscribedGroups'] = m.unsubscribedGroups.map(e => e);
    }
    if (m.unsubscribeType !== undefined)
        o['unsubscribeType'] = m.unsubscribeType;
    if (m.unsubscribedDomain !== undefined)
        o['unsubscribedDomain'] = m.unsubscribedDomain;
    return o;
}
export function statusFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        recipientEmail: (_a = o['recipientEmail']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'RECIPIENT_STATUS_INVALID',
        infractionCount: (_c = o['infractionCount']) !== null && _c !== void 0 ? _c : 0,
        bounceExpiry: o['bounceExpiry'] ? new Date(o['bounceExpiry']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        lastUpdated: o['lastUpdated'] ? new Date(o['lastUpdated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        unsubscribed: (_d = o['unsubscribed']) !== null && _d !== void 0 ? _d : false,
        unsubscribedGroups: ((_e = o['unsubscribedGroups']) !== null && _e !== void 0 ? _e : []).map(e => e),
        unsubscribeType: (_f = o['unsubscribeType']) !== null && _f !== void 0 ? _f : '',
        unsubscribedDomain: (_g = o['unsubscribedDomain']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getInboundMessageRequestToJson(m) {
    const o = {};
    if (m.emailId !== undefined)
        o['emailId'] = m.emailId;
    return o;
}
export function getInboundMessageRequestFromJson(o) {
    var _a;
    return {
        emailId: (_a = o['emailId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getInboundMessageResponseToJson(m) {
    const o = {};
    if (m.inboundMessage !== undefined)
        o['inboundMessage'] = inboundMessageToJson(m.inboundMessage);
    return o;
}
export function getInboundMessageResponseFromJson(o) {
    return {
        inboundMessage: o['inboundMessage'] ? inboundMessageFromJson(o['inboundMessage']) : undefined,
    };
}
export function createInboundMessageMappingRequestToJson(m) {
    const o = {};
    if (m.appNamespace !== undefined)
        o['appNamespace'] = m.appNamespace;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    if (m.attributes !== undefined) {
        o['attributes'] = m.attributes.map(e => attributeToJson(e));
    }
    return o;
}
export function createInboundMessageMappingRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appNamespace: (_a = o['appNamespace']) !== null && _a !== void 0 ? _a : '',
        idempotencyKey: (_b = o['idempotencyKey']) !== null && _b !== void 0 ? _b : '',
        attributes: ((_c = o['attributes']) !== null && _c !== void 0 ? _c : []).map(e => attributeFromJson(e)),
    };
}
export function createInboundMessageMappingResponseToJson(m) {
    const o = {};
    if (m.mappingId !== undefined)
        o['mappingId'] = m.mappingId;
    return o;
}
export function createInboundMessageMappingResponseFromJson(o) {
    var _a;
    return {
        mappingId: (_a = o['mappingId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getInboundMessageMappingRequestToJson(m) {
    const o = {};
    if (m.appNamespace !== undefined)
        o['appNamespace'] = m.appNamespace;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    return o;
}
export function getInboundMessageMappingRequestFromJson(o) {
    var _a, _b;
    return {
        appNamespace: (_a = o['appNamespace']) !== null && _a !== void 0 ? _a : '',
        idempotencyKey: (_b = o['idempotencyKey']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getInboundMessageMappingResponseToJson(m) {
    const o = {};
    if (m.inboundMessageMapping !== undefined)
        o['inboundMessageMapping'] = inboundMessageMappingToJson(m.inboundMessageMapping);
    return o;
}
export function getInboundMessageMappingResponseFromJson(o) {
    return {
        inboundMessageMapping: o['inboundMessageMapping'] ? inboundMessageMappingFromJson(o['inboundMessageMapping']) : undefined,
    };
}
export function getReplyEmailRequestToJson(m) {
    const o = {};
    if (m.sender !== undefined)
        o['sender'] = senderToJson(m.sender);
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    return o;
}
export function getReplyEmailRequestFromJson(o) {
    var _a;
    return {
        sender: o['sender'] ? senderFromJson(o['sender']) : undefined,
        idempotencyKey: (_a = o['idempotencyKey']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getReplyEmailResponseToJson(m) {
    const o = {};
    if (m.replyAddress !== undefined)
        o['replyAddress'] = m.replyAddress;
    return o;
}
export function getReplyEmailResponseFromJson(o) {
    var _a;
    return {
        replyAddress: (_a = o['replyAddress']) !== null && _a !== void 0 ? _a : '',
    };
}
export function validateEmailAddressRequestToJson(m) {
    const o = {};
    if (m.email !== undefined)
        o['email'] = m.email;
    return o;
}
export function validateEmailAddressRequestFromJson(o) {
    var _a;
    return {
        email: (_a = o['email']) !== null && _a !== void 0 ? _a : '',
    };
}
export function validateEmailAddressResponseToJson(m) {
    const o = {};
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.invalidReason !== undefined)
        o['invalidReason'] = m.invalidReason;
    return o;
}
export function validateEmailAddressResponseFromJson(o) {
    var _a, _b;
    return {
        isValid: (_a = o['isValid']) !== null && _a !== void 0 ? _a : false,
        invalidReason: (_b = o['invalidReason']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSignatureRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.provider !== undefined)
        o['provider'] = m.provider;
    if (m.connectionId !== undefined)
        o['connectionId'] = m.connectionId;
    return o;
}
export function getSignatureRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        provider: (_b = o['provider']) !== null && _b !== void 0 ? _b : 'PROVIDER_INVALID',
        connectionId: (_c = o['connectionId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getSignatureResponseToJson(m) {
    const o = {};
    if (m.html !== undefined)
        o['html'] = m.html;
    return o;
}
export function getSignatureResponseFromJson(o) {
    var _a;
    return {
        html: (_a = o['html']) !== null && _a !== void 0 ? _a : '',
    };
}
export function saveDraftRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.provider !== undefined)
        o['provider'] = m.provider;
    if (m.message !== undefined)
        o['message'] = whiteLabelEmailMessageToJson(m.message);
    if (m.toRecipients !== undefined) {
        o['toRecipients'] = m.toRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.ccRecipients !== undefined) {
        o['ccRecipients'] = m.ccRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.bccRecipients !== undefined) {
        o['bccRecipients'] = m.bccRecipients.map(e => emailRecipientToJson(e));
    }
    if (m.providerMessageThreadId !== undefined)
        o['providerMessageThreadId'] = m.providerMessageThreadId;
    if (m.inReplyToMessageId !== undefined)
        o['inReplyToMessageId'] = m.inReplyToMessageId;
    if (m.visibility !== undefined)
        o['visibility'] = m.visibility;
    if (m.sourceInfo !== undefined)
        o['sourceInfo'] = sourceInfoToJson(m.sourceInfo);
    if (m.fromConnectionId !== undefined)
        o['fromConnectionId'] = m.fromConnectionId;
    if (m.idempotencyKey !== undefined)
        o['idempotencyKey'] = m.idempotencyKey;
    return o;
}
export function saveDraftRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        provider: (_b = o['provider']) !== null && _b !== void 0 ? _b : 'PROVIDER_INVALID',
        message: o['message'] ? whiteLabelEmailMessageFromJson(o['message']) : undefined,
        toRecipients: ((_c = o['toRecipients']) !== null && _c !== void 0 ? _c : []).map(e => emailRecipientFromJson(e)),
        ccRecipients: ((_d = o['ccRecipients']) !== null && _d !== void 0 ? _d : []).map(e => emailRecipientFromJson(e)),
        bccRecipients: ((_e = o['bccRecipients']) !== null && _e !== void 0 ? _e : []).map(e => emailRecipientFromJson(e)),
        providerMessageThreadId: (_f = o['providerMessageThreadId']) !== null && _f !== void 0 ? _f : '',
        inReplyToMessageId: (_g = o['inReplyToMessageId']) !== null && _g !== void 0 ? _g : '',
        visibility: (_h = o['visibility']) !== null && _h !== void 0 ? _h : 'VISIBILITY_INVALID',
        sourceInfo: o['sourceInfo'] ? sourceInfoFromJson(o['sourceInfo']) : undefined,
        fromConnectionId: (_j = o['fromConnectionId']) !== null && _j !== void 0 ? _j : '',
        idempotencyKey: (_k = o['idempotencyKey']) !== null && _k !== void 0 ? _k : '',
    };
}
export function saveDraftResponseToJson(m) {
    const o = {};
    if (m.trackedMessageId !== undefined)
        o['trackedMessageId'] = m.trackedMessageId;
    return o;
}
export function saveDraftResponseFromJson(o) {
    var _a;
    return {
        trackedMessageId: (_a = o['trackedMessageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateDraftRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.trackedMessageId !== undefined)
        o['trackedMessageId'] = m.trackedMessageId;
    if (m.message !== undefined)
        o['message'] = whiteLabelEmailMessageToJson(m.message);
    return o;
}
export function updateDraftRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        trackedMessageId: (_b = o['trackedMessageId']) !== null && _b !== void 0 ? _b : '',
        message: o['message'] ? whiteLabelEmailMessageFromJson(o['message']) : undefined,
    };
}
export function updateDraftResponseToJson(m) {
    const o = {};
    return o;
}
export function updateDraftResponseFromJson(o) {
    return {};
}
export function discardDraftRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = m.namespace;
    if (m.trackedMessageId !== undefined)
        o['trackedMessageId'] = m.trackedMessageId;
    return o;
}
export function discardDraftRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: (_a = o['namespace']) !== null && _a !== void 0 ? _a : '',
        trackedMessageId: (_b = o['trackedMessageId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function discardDraftResponseToJson(m) {
    const o = {};
    return o;
}
export function discardDraftResponseFromJson(o) {
    return {};
}
